/* Asistente La Flama (snippets/lf-asistente.liquid).
   Chat sin IA: entiende frases sencillas, conoce todo el catálogo y recomienda discos.
   Catálogo: /collections/all?view=lf-datos (templates/collection.lf-datos.liquid).
   Multilingüe: es (por defecto), ca, en, gl, eu. Idioma = <html lang>. Textos en TXT; palabras clave en KW
   (las de los 5 idiomas se mezclan siempre, para entender a quien escriba en cualquiera de ellos). */
(function () {
  var raiz = document.getElementById('lf-asis');
  if (!raiz || raiz.dataset.listo) return;
  raiz.dataset.listo = '1';
  document.body.appendChild(raiz);
  raiz.hidden = false;

  var RAIZ_URL = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var IDIOMAS = ['es', 'ca', 'en', 'gl', 'eu'];
  var IDIOMA = (document.documentElement.lang || 'es').slice(0, 2).toLowerCase();
  if (IDIOMAS.indexOf(IDIOMA) === -1) IDIOMA = 'es';
  var lanzador = raiz.querySelector('.lf-asis__lanzador');
  var panel = raiz.querySelector('.lf-asis__panel');
  var lista = raiz.querySelector('.lf-asis__mensajes');
  var entrada = raiz.querySelector('#lf-asis-texto');
  var aviso = raiz.querySelector('.lf-asis__aviso');
  var productoActual = raiz.dataset.producto || '';
  var plantilla = raiz.dataset.plantilla || '';
  var iniciado = false;
  var catalogo = null;
  var perfil = {};
  var cola = Promise.resolve();

  /* ---------- Textos por idioma ---------- */
  /* Los textos van entre comillas invertidas (sin escapes). {nombre} se sustituye con los datos de tx(). */
  /* ==TXT== */
  var TXT = {
    es: {
      agotado: `agotado`,
      dec: `,`,
      precio_fmt: `{n} €`,
      rec_set: `Para empezar te recomiendo <strong>un putter, un midrange y un fairway driver</strong>. Con estos tres puedes jugar cualquier hoyo:`,
      rec_packs: `O llévate un pack ya preparado:`,
      rec_mas_primer: `Cómo elegir tu primer disco`,
      rec_vacio: `Ahora mismo no tengo discos con existencias que encajen{marca}. Mira los <a href="{u}">{n}</a> o escríbenos y te aconsejamos:`,
      de_marca_vacio: ` de {m}`,
      rec_fairway_principiante: `Si estás empezando, un <strong>fairway driver</strong> te llevará más lejos que un driver de distancia, porque necesita menos brazo. `,
      desc_orden: [`tipo`, `vuelo`, `nivel`, `marca`],
      de_marca: `de {m}`,
      vuelo_recto: `rectos`,
      vuelo_facil: `fáciles de lanzar`,
      vuelo_viento: `que aguantan el viento`,
      nivel_principiante: `para empezar`,
      nivel_intermedio: `para jugadores con experiencia`,
      nivel_avanzado: `para competir`,
      rec_intro: [`Perfecto, estos son los {d} que yo me llevaría:`, `Te recomiendo estos {d}:`, `Mira estos {d}, creo que te van a gustar:`],
      rec_ver_todos: `Ver todos los {n}`,
      tipo_putter: `putters`,
      tipo_mid: `midranges`,
      tipo_fairway: `fairway drivers`,
      tipo_distance: `distance drivers`,
      tipo_driver: `drivers`,
      nv_princ: `Es un buen disco para empezar.`,
      nv_todos: `Sirve para todos los niveles.`,
      nv_avanz: `Rinde mejor con experiencia y brazo.`,
      nv_avanz2: `Es mejor para jugadores con experiencia y brazo.`,
      info_precio: `El <strong>{n}</strong> lo tienes desde <strong>{p}</strong>{fin} `,
      segun_plastico: `, según el plástico.`,
      info_si: `¡Sí! Tengo el <strong>{n}</strong>. `,
      info_agotado: `El <strong>{n}</strong> ahora mismo está agotado. `,
      info_vuela_n: `El <strong>{n}</strong> vuela `,
      info_vuela: `Vuela `,
      versiones: `Lo tengo en {k} versiones:`,
      lo_tengo: `Lo tengo aquí:`,
      agotado_aviso: `Ahora mismo está agotado. En su ficha puedes pedir que te avisemos:`,
      op_compara: `¿Con qué se compara?`,
      op_parecidos: `Discos parecidos`,
      op_otra: `Otra pregunta`,
      parecido_a: `Con un vuelo parecido al {n} tengo estos:`,
      otra_a: [`Dime, ¿qué más necesitas?`, `Pregúntame lo que sea.`],
      otra_b: [`Dime, ¿qué más necesitas?`, `Claro, escríbeme abajo lo que quieras.`, `Pregúntame lo que sea.`],
      cmp_rapido: `El <strong>{a}</strong> es más rápido (speed {x} frente a {y}), así que necesita más brazo para volar bien.`,
      cmp_estable: `El <strong>{a}</strong> es más estable: aguanta mejor el viento y cierra más al final. El <strong>{b}</strong> es más fácil de lanzar y tiende a irse más recto o a girar.`,
      cmp_planea: `El <strong>{a}</strong> planea más, ideal para ganar metros sin forzar.`,
      cmp_igual: `Vuelan de forma muy parecida. La diferencia está sobre todo en el plástico y en el tacto en la mano.`,
      cmp_cab: `{a} ({x}) frente a {b} ({y}):<br><br>`,
      pl_con_marca: `El <strong>{n}</strong> es un plástico de {m}. `,
      pl_sin_marca: `El <strong>{n}</strong>. `,
      pl_familia: `<br><br>De esta familia tengo: {l}.`,
      pl_discos: `Algunos discos en {n}:`,
      err_catalogo: `No he podido cargar el catálogo ahora. Mira <a href="{u}">todos los productos</a> o escríbenos a <a href="mailto:dglaflama@gmail.com">dglaflama@gmail.com</a>.`,
      q_nivel: [`Para recomendarte bien, ¿cuánto tiempo llevas jugando?`, `Vamos a ello. Primero, ¿cuánto llevas jugando al disc golf?`],
      op_empezando: `Estoy empezando`,
      op_menudo: `Juego a menudo`,
      op_compito: `Compito`,
      q_tipo: [`¿Y qué tipo de disco buscas?`, `Genial. ¿Qué disco te falta en la bolsa?`],
      op_set: `Mis primeros discos (un set)`,
      op_putter: `Putter para la cesta y tiros cortos`,
      op_mid: `Midrange para tiros medios`,
      op_driver: `Driver para salir lejos`,
      q_vuelo: [`¿Cómo te gustaría que volara?`, `Última pregunta: ¿cómo quieres que vuele?`],
      op_recto: `Recto`,
      op_facil: `Que se abra fácil y planee`,
      op_viento: `Que aguante el viento`,
      op_igual: `Me da igual`,
      r_envio: `Enviamos a <strong>toda España con Correos por 8,50 €</strong>, también a Baleares, Canarias, Ceuta y Melilla. Cuando sale tu pedido te mandamos el número de seguimiento.<br><br>Si juegas en el Parc de l'Hostal del Fum (Palau-solità i Plegamans), la <strong>recogida es gratis</strong>: elígela al pagar. <a href="{u}">Ver envíos</a>`,
      r_recogida: `Puedes <strong>recoger gratis</strong> tu pedido en el Parc de l'Hostal del Fum (Palau-solità i Plegamans): elige esa opción al pagar y quedamos contigo. En la zona de Barcelona también te lo llevamos en mano (8 € o 15 € según la zona). <a href="{u}">Ver envíos</a>`,
      r_devolucion: `Tienes <strong>14 días</strong> para devolver tu compra sin dar motivos, con el disco sin lanzar. Si prefieres otro peso, color o disco, te lo cambiamos si hay existencias. Escríbenos a <a href="mailto:dglaflama@gmail.com">dglaflama@gmail.com</a> con tu número de pedido. <a href="{u}">Ver devoluciones</a>`,
      r_club: `Con el <strong>Club La Flama</strong> sumas puntos con cada compra y los canjeas por descuentos. Si tu club de disc golf se une, además tienes 1 € de descuento en cada disco. <a href="{u}">Conoce el Club</a>`,
      r_campos: `Tenemos un mapa con los campos de disc golf de España, con cómo llegar a cada uno. <a href="{u}">Ver campos</a>`,
      r_ligas: `En Ligas verás las ligas de los clubs que están en marcha y cómo apuntarte. Si organizas una, también puedes enviárnosla. <a href="{u}">Ver ligas</a>`,
      r_vuelo: `Los 4 números de un disco son <strong>speed</strong> (velocidad), <strong>glide</strong> (planeo), <strong>turn</strong> (cuánto se abre al principio) y <strong>fade</strong> (cuánto cierra al final). Cuanto más negativo el turn, más fácil de lanzar. <a href="{u}">Leer la guía</a>`,
      r_plastico: `El plástico cambia el agarre, la durabilidad y el precio: los blandos agarran mejor, los premium duran más y mantienen el vuelo. <a href="{u}">Guía de plásticos</a>`,
      r_peso: `Si estás empezando, un disco algo más ligero (por debajo de 170 g) es más fácil de lanzar lejos. Los más pesados aguantan mejor el viento. El peso de cada disco está en su ficha.`,
      r_reglas: `El disc golf se juega como el golf, pero lanzando discos a una cesta. <a href="{u1}">Reglas básicas</a> · <a href="{u2}">¿Qué es el disc golf?</a>`,
      r_encamino: `Los discos que están de camino están en <a href="{u}">¡En camino!</a> y puedes reservarlos. Si un disco está agotado, en su ficha puedes pedir que te avisemos cuando vuelva.`,
      r_descuentos_club: `Con el <strong>Club La Flama</strong> sumas puntos en cada compra y los canjeas por descuentos de 5 € a 20 €. Si tu club se une, tienes además 1 € de descuento en cada disco. <a href="{u}">Conoce el Club</a>`,
      camp_fin: ` (hasta el {f})`,
      camp_ver: ` <a href="{u}">Ver</a>`,
      d_rebajados: `Y ahora mismo tienes estos productos rebajados:`,
      d_xout: `Si buscas algo más económico, mira los discos X-out: son discos con pequeños defectos de estampado, que vuelan igual y cuestan menos.`,
      r_regalo: `Para regalar tienes la tarjeta <strong>Regala la Flama</strong> (desde 5 €), y quien la recibe elige lo que quiera. Si prefieres sorprender, las cajas sorpresa <strong>Flama Box</strong> son un regalo muy chulo. <a href="{u}">Ver tarjeta regalo</a>`,
      d_cajas: `Estas son las cajas y packs que tengo ahora:`,
      r_tienda: `Somos una tienda online, pero puedes <strong>recoger tu pedido gratis</strong> en el Parc de l'Hostal del Fum (Palau-solità i Plegamans): elige esa opción al pagar y quedamos contigo. ¿Quieres probar un disco antes? Escríbenos y lo hablamos.`,
      r_pago: `Al finalizar la compra verás todas las formas de pago disponibles. Si tienes cualquier problema al pagar, escríbenos a <a href="mailto:dglaflama@gmail.com">dglaflama@gmail.com</a>.`,
      r_contacto: `Escríbenos cuando quieras: <a href="mailto:dglaflama@gmail.com">dglaflama@gmail.com</a> o por Instagram en <a href="https://ig.me/m/discgolf.laflama" target="_blank" rel="noopener">@discgolf.laflama</a>. También puedes dejarnos tu mensaje aquí:`,
      p_saludo: `¡Hola! ¿Qué estás buscando? Puedes escribirme cosas como «putter para viento», «driver para empezar» o «packs».`,
      p_gracias: `¡A ti! Si necesitas algo más, aquí estoy.`,
      par_con: `Discos con un vuelo parecido al <strong>{n}</strong> ({s}):`,
      par_no: `Ese disco no lo tengo en la tienda, pero te busco uno parecido. Cuéntame un poco:`,
      enc_uno: [`¡Sí! Tengo esto:`, `Tengo justo esto:`],
      enc_varios: [`¡Claro! Mira lo que tengo:`, `Sí, tengo varias cosas que te pueden encajar:`, `Mira, esto es lo que tengo:`],
      enc_agotado: `Ahora mismo está agotado, pero en la ficha puedes pedir que te avisemos.`,
      ver_resultados: `Ver los {k} resultados`,
      op_no_busco: `No es lo que busco`,
      op_que_disco: `¿Qué disco necesito?`,
      pide_correo: `Cuéntanos qué buscas y te respondemos por correo:`,
      s_nada_a: [`Vaya, eso no lo tengo ahora mismo.`, `Uf, eso no lo encuentro en la tienda.`],
      s_nada_b: ` Puedo buscarte algo parecido o, si nos dejas tu correo, miramos si podemos conseguirlo.`,
      op_buscar_parecido: `Buscar algo parecido`,
      op_pedir: `Pedir que lo consigáis`,
      s_pide_correo: `Genial, dinos qué buscas y te respondemos por correo:`,
      s_encontrado: `Esto es lo que he encontrado:`,
      s_error: `No he podido buscar ahora. Escríbenos a <a href="mailto:dglaflama@gmail.com">dglaflama@gmail.com</a> y te ayudamos.`,
      m_packs: `Packs y cajas sorpresa`,
      m_ofertas: `Ofertas y descuentos`,
      m_envios: `Envíos y recogida`,
      m_cambios: `Cambios y devoluciones`,
      m_club: `Club La Flama`,
      m_hablar: `Hablar con nosotros`,
      op_buscar_otro: `Buscar otro disco`,
      f_viendo: `Estás viendo el <strong>{n}</strong> ({s}). {nv}`,
      f_parecido: `Con un vuelo parecido tengo estos:`,
      h_de_nuevo: [`¡Hola de nuevo! ¿Te ayudo con algo más?`, `¿Seguimos? Dime qué más necesitas.`],
      h_inicio: [`¡Hola! 👋 Soy L'Espurna y te ayudo a encontrar tu disco.`, `¡Hola! Bienvenido a La Flama 🔥`],
      h_inicio_b: ` Conozco todo lo que hay en la tienda: pregúntame por un disco, una marca, un pack o cualquier duda, como si me escribieras por WhatsApp.`,
      h_buscador: `¡Hola! Vamos a encontrar tu disco.`,
      h_gracias: `¡Gracias! Hemos recibido tu mensaje y te responderemos por correo.`
    },

    ca: {
      agotado: `esgotat`,
      dec: `,`,
      precio_fmt: `{n} €`,
      rec_set: `Per començar et recomano <strong>un putter, un midrange i un fairway driver</strong>. Amb aquests tres pots jugar qualsevol forat:`,
      rec_packs: `O endu-te un pack ja preparat:`,
      rec_mas_primer: `Com triar el teu primer disc`,
      rec_vacio: `Ara mateix no tinc discos amb existències que hi encaixin{marca}. Mira els <a href="{u}">{n}</a> o escriu-nos i t'aconsellem:`,
      de_marca_vacio: ` de {m}`,
      rec_fairway_principiante: `Si estàs començant, un <strong>fairway driver</strong> et portarà més lluny que un driver de distància, perquè necessita menys braç. `,
      desc_orden: [`tipo`, `vuelo`, `nivel`, `marca`],
      de_marca: `de {m}`,
      vuelo_recto: `rectes`,
      vuelo_facil: `fàcils de llançar`,
      vuelo_viento: `que aguanten el vent`,
      nivel_principiante: `per començar`,
      nivel_intermedio: `per a jugadors amb experiència`,
      nivel_avanzado: `per competir`,
      rec_intro: [`Perfecte, aquests són els {d} que jo m'enduria:`, `Et recomano aquests {d}:`, `Mira aquests {d}, crec que t'agradaran:`],
      rec_ver_todos: `Veure tots els {n}`,
      tipo_putter: `putters`,
      tipo_mid: `midranges`,
      tipo_fairway: `fairway drivers`,
      tipo_distance: `distance drivers`,
      tipo_driver: `drivers`,
      nv_princ: `És un bon disc per començar.`,
      nv_todos: `Serveix per a tots els nivells.`,
      nv_avanz: `Rendeix millor amb experiència i braç.`,
      nv_avanz2: `És millor per a jugadors amb experiència i braç.`,
      info_precio: `El <strong>{n}</strong> el tens des de <strong>{p}</strong>{fin} `,
      segun_plastico: `, segons el plàstic.`,
      info_si: `Sí! Tinc el <strong>{n}</strong>. `,
      info_agotado: `El <strong>{n}</strong> ara mateix està esgotat. `,
      info_vuela_n: `El <strong>{n}</strong> vola `,
      info_vuela: `Vola `,
      versiones: `El tinc en {k} versions:`,
      lo_tengo: `El tinc aquí:`,
      agotado_aviso: `Ara mateix està esgotat. A la seva fitxa pots demanar que t'avisem:`,
      op_compara: `Amb què es compara?`,
      op_parecidos: `Discos semblants`,
      op_otra: `Una altra pregunta`,
      parecido_a: `Amb un vol semblant al {n} tinc aquests:`,
      otra_a: [`Digues, què més necessites?`, `Pregunta'm el que vulguis.`],
      otra_b: [`Digues, què més necessites?`, `És clar, escriu-me a sota el que vulguis.`, `Pregunta'm el que vulguis.`],
      cmp_rapido: `El <strong>{a}</strong> és més ràpid (speed {x} davant de {y}), així que necessita més braç per volar bé.`,
      cmp_estable: `El <strong>{a}</strong> és més estable: aguanta millor el vent i tanca més al final. El <strong>{b}</strong> és més fàcil de llançar i tendeix a anar més recte o a girar.`,
      cmp_planea: `El <strong>{a}</strong> planeja més, ideal per guanyar metres sense forçar.`,
      cmp_igual: `Volen de manera molt semblant. La diferència és sobretot en el plàstic i en la sensació a la mà.`,
      cmp_cab: `{a} ({x}) davant de {b} ({y}):<br><br>`,
      pl_con_marca: `El <strong>{n}</strong> és un plàstic de {m}. `,
      pl_sin_marca: `El <strong>{n}</strong>. `,
      pl_familia: `<br><br>D'aquesta família tinc: {l}.`,
      pl_discos: `Alguns discos en {n}:`,
      err_catalogo: `No he pogut carregar el catàleg ara. Mira <a href="{u}">tots els productes</a> o escriu-nos a <a href="mailto:dglaflama@gmail.com">dglaflama@gmail.com</a>.`,
      q_nivel: [`Per recomanar-te bé, quant fa que jugues?`, `Som-hi. Primer, quant fa que jugues a disc golf?`],
      op_empezando: `Estic començant`,
      op_menudo: `Juguo sovint`,
      op_compito: `Competeixo`,
      q_tipo: [`I quin tipus de disc busques?`, `Genial. Quin disc et falta a la bossa?`],
      op_set: `Els meus primers discos (un set)`,
      op_putter: `Putter per a la cistella i tirs curts`,
      op_mid: `Midrange per a tirs mitjans`,
      op_driver: `Driver per sortir lluny`,
      q_vuelo: [`Com t'agradaria que volés?`, `Última pregunta: com vols que voli?`],
      op_recto: `Recte`,
      op_facil: `Que s'obri fàcil i planegi`,
      op_viento: `Que aguanti el vent`,
      op_igual: `M'és igual`,
      r_envio: `Enviem a <strong>tot Espanya amb Correos per 8,50 €</strong>, també a les Balears, Canàries, Ceuta i Melilla. Quan surt la teva comanda t'enviem el número de seguiment.<br><br>Si jugues al Parc de l'Hostal del Fum (Palau-solità i Plegamans), la <strong>recollida és gratuïta</strong>: tria-la en pagar. <a href="{u}">Veure enviaments</a>`,
      r_recogida: `Pots <strong>recollir gratis</strong> la teva comanda al Parc de l'Hostal del Fum (Palau-solità i Plegamans): tria aquesta opció en pagar i quedem amb tu. A la zona de Barcelona també te la portem en mà (8 € o 15 € segons la zona). <a href="{u}">Veure enviaments</a>`,
      r_devolucion: `Tens <strong>14 dies</strong> per retornar la teva compra sense donar motius, amb el disc sense llançar. Si prefereixes un altre pes, color o disc, te'l canviem si hi ha existències. Escriu-nos a <a href="mailto:dglaflama@gmail.com">dglaflama@gmail.com</a> amb el teu número de comanda. <a href="{u}">Veure devolucions</a>`,
      r_club: `Amb el <strong>Club La Flama</strong> sumes punts amb cada compra i els bescanvies per descomptes. Si el teu club de disc golf s'uneix, a més tens 1 € de descompte a cada disc. <a href="{u}">Coneix el Club</a>`,
      r_campos: `Tenim un mapa amb els camps de disc golf d'Espanya, amb com arribar a cadascun. <a href="{u}">Veure camps</a>`,
      r_ligas: `A Lligues veuràs les lligues dels clubs que estan en marxa i com apuntar-te. Si en organitzes una, també ens la pots enviar. <a href="{u}">Veure lligues</a>`,
      r_vuelo: `Els 4 números d'un disc són <strong>speed</strong> (velocitat), <strong>glide</strong> (planeig), <strong>turn</strong> (quant s'obre al principi) i <strong>fade</strong> (quant tanca al final). Com més negatiu és el turn, més fàcil de llançar. <a href="{u}">Llegir la guia</a>`,
      r_plastico: `El plàstic canvia l'agafada, la durabilitat i el preu: els tous agafen millor, els premium duren més i mantenen el vol. <a href="{u}">Guia de plàstics</a>`,
      r_peso: `Si estàs començant, un disc una mica més lleuger (per sota de 170 g) és més fàcil de llançar lluny. Els més pesats aguanten millor el vent. El pes de cada disc és a la seva fitxa.`,
      r_reglas: `El disc golf es juga com el golf, però llançant discos a una cistella. <a href="{u1}">Regles bàsiques</a> · <a href="{u2}">Què és el disc golf?</a>`,
      r_encamino: `Els discos que són de camí són a <a href="{u}">En camí!</a> i els pots reservar. Si un disc està esgotat, a la seva fitxa pots demanar que t'avisem quan torni.`,
      r_descuentos_club: `Amb el <strong>Club La Flama</strong> sumes punts a cada compra i els bescanvies per descomptes de 5 € a 20 €. Si el teu club s'uneix, tens a més 1 € de descompte a cada disc. <a href="{u}">Coneix el Club</a>`,
      camp_fin: ` (fins al {f})`,
      camp_ver: ` <a href="{u}">Veure</a>`,
      d_rebajados: `I ara mateix tens aquests productes rebaixats:`,
      d_xout: `Si busques alguna cosa més econòmica, mira els discos X-out: són discos amb petits defectes d'estampació, que volen igual i costen menys.`,
      r_regalo: `Per regalar tens la targeta <strong>Regala la Flama</strong> (des de 5 €), i qui la rep tria el que vulgui. Si prefereixes sorprendre, les caixes sorpresa <strong>Flama Box</strong> són un regal molt xulo. <a href="{u}">Veure targeta regal</a>`,
      d_cajas: `Aquestes són les caixes i packs que tinc ara:`,
      r_tienda: `Som una botiga en línia, però pots <strong>recollir la teva comanda gratis</strong> al Parc de l'Hostal del Fum (Palau-solità i Plegamans): tria aquesta opció en pagar i quedem amb tu. Vols provar un disc abans? Escriu-nos i ho parlem.`,
      r_pago: `En finalitzar la compra veuràs totes les formes de pagament disponibles. Si tens qualsevol problema en pagar, escriu-nos a <a href="mailto:dglaflama@gmail.com">dglaflama@gmail.com</a>.`,
      r_contacto: `Escriu-nos quan vulguis: <a href="mailto:dglaflama@gmail.com">dglaflama@gmail.com</a> o per Instagram a <a href="https://ig.me/m/discgolf.laflama" target="_blank" rel="noopener">@discgolf.laflama</a>. També pots deixar-nos el teu missatge aquí:`,
      p_saludo: `Hola! Què estàs buscant? Pots escriure'm coses com «putter per al vent», «driver per començar» o «packs».`,
      p_gracias: `A tu! Si necessites res més, aquí em tens.`,
      par_con: `Discos amb un vol semblant al <strong>{n}</strong> ({s}):`,
      par_no: `Aquest disc no el tinc a la botiga, però et busco un de semblant. Explica'm una mica:`,
      enc_uno: [`Sí! Tinc això:`, `Tinc just això:`],
      enc_varios: [`És clar! Mira què tinc:`, `Sí, tinc diverses coses que et poden encaixar:`, `Mira, això és el que tinc:`],
      enc_agotado: `Ara mateix està esgotat, però a la fitxa pots demanar que t'avisem.`,
      ver_resultados: `Veure els {k} resultats`,
      op_no_busco: `No és el que busco`,
      op_que_disco: `Quin disc necessito?`,
      pide_correo: `Explica'ns què busques i et respondrem per correu:`,
      s_nada_a: [`Vaja, això ara mateix no ho tinc.`, `Uf, això no ho trobo a la botiga.`],
      s_nada_b: ` Et puc buscar alguna cosa semblant o, si ens deixes el teu correu, mirem si ho podem aconseguir.`,
      op_buscar_parecido: `Buscar alguna cosa semblant`,
      op_pedir: `Demanar que ho aconseguiu`,
      s_pide_correo: `Genial, digue'ns què busques i et respondrem per correu:`,
      s_encontrado: `Això és el que he trobat:`,
      s_error: `No he pogut buscar ara. Escriu-nos a <a href="mailto:dglaflama@gmail.com">dglaflama@gmail.com</a> i t'ajudem.`,
      m_packs: `Packs i caixes sorpresa`,
      m_ofertas: `Ofertes i descomptes`,
      m_envios: `Enviaments i recollida`,
      m_cambios: `Canvis i devolucions`,
      m_club: `Club La Flama`,
      m_hablar: `Parlar amb nosaltres`,
      op_buscar_otro: `Buscar un altre disc`,
      f_viendo: `Estàs veient el <strong>{n}</strong> ({s}). {nv}`,
      f_parecido: `Amb un vol semblant tinc aquests:`,
      h_de_nuevo: [`Hola de nou! Et puc ajudar amb alguna cosa més?`, `Seguim? Digue'm què més necessites.`],
      h_inicio: [`Hola! 👋 Sóc L'Espurna i t'ajudo a trobar el teu disc.`, `Hola! Et donem la benvinguda a La Flama 🔥`],
      h_inicio_b: ` Conec tot el que hi ha a la botiga: pregunta'm per un disc, una marca, un pack o qualsevol dubte, com si m'escrivissis per WhatsApp.`,
      h_buscador: `Hola! Anem a trobar el teu disc.`,
      h_gracias: `Gràcies! Hem rebut el teu missatge i et respondrem per correu.`
    },

    en: {
      agotado: `sold out`,
      dec: `.`,
      precio_fmt: `€{n}`,
      rec_set: `To get started I recommend <strong>a putter, a midrange and a fairway driver</strong>. With these three you can play any hole:`,
      rec_packs: `Or grab a ready-made pack:`,
      rec_mas_primer: `How to choose your first disc`,
      rec_vacio: `Right now I don't have any discs in stock{marca} that fit. Take a look at the <a href="{u}">{n}</a> or write to us and we'll advise you:`,
      de_marca_vacio: ` from {m}`,
      rec_fairway_principiante: `If you're just starting out, a <strong>fairway driver</strong> will take you further than a distance driver, because it needs less arm. `,
      desc_orden: [`marca`, `nivel`, `vuelo`, `tipo`],
      de_marca: `{m}`,
      vuelo_recto: `straight-flying`,
      vuelo_facil: `easy-to-throw`,
      vuelo_viento: `wind-resistant`,
      nivel_principiante: `beginner-friendly`,
      nivel_intermedio: `intermediate`,
      nivel_avanzado: `competition-level`,
      rec_intro: [`Perfect, these are the {d} I'd take:`, `I recommend these {d}:`, `Check out these {d}, I think you'll like them:`],
      rec_ver_todos: `See all {n}`,
      tipo_putter: `putters`,
      tipo_mid: `midranges`,
      tipo_fairway: `fairway drivers`,
      tipo_distance: `distance drivers`,
      tipo_driver: `drivers`,
      nv_princ: `It's a good disc to get started with.`,
      nv_todos: `It works for all levels.`,
      nv_avanz: `It performs best with experience and arm speed.`,
      nv_avanz2: `It's better for experienced players with a strong arm.`,
      info_precio: `The <strong>{n}</strong> starts at <strong>{p}</strong>{fin} `,
      segun_plastico: `, depending on the plastic.`,
      info_si: `Yes! I've got the <strong>{n}</strong>. `,
      info_agotado: `The <strong>{n}</strong> is sold out right now. `,
      info_vuela_n: `The <strong>{n}</strong> has flight numbers `,
      info_vuela: `Flight numbers: `,
      versiones: `I have it in {k} versions:`,
      lo_tengo: `I have it right here:`,
      agotado_aviso: `It's sold out right now. On its page you can ask us to let you know:`,
      op_compara: `What does it compare to?`,
      op_parecidos: `Similar discs`,
      op_otra: `Another question`,
      parecido_a: `With a flight similar to the {n} I've got these:`,
      otra_a: [`Tell me, what else do you need?`, `Ask me anything.`],
      otra_b: [`Tell me, what else do you need?`, `Sure, type whatever you want below.`, `Ask me anything.`],
      cmp_rapido: `The <strong>{a}</strong> is faster (speed {x} vs {y}), so it needs more arm to fly well.`,
      cmp_estable: `The <strong>{a}</strong> is more stable: it handles wind better and fades harder at the end. The <strong>{b}</strong> is easier to throw and tends to go straighter or turn over.`,
      cmp_planea: `The <strong>{a}</strong> glides more, ideal for gaining distance without forcing it.`,
      cmp_igual: `They fly very similarly. The difference is mostly in the plastic and the feel in the hand.`,
      cmp_cab: `{a} ({x}) vs {b} ({y}):<br><br>`,
      pl_con_marca: `The <strong>{n}</strong> is a {m} plastic. `,
      pl_sin_marca: `The <strong>{n}</strong>. `,
      pl_familia: `<br><br>From this family I have: {l}.`,
      pl_discos: `Some discs in {n}:`,
      err_catalogo: `I couldn't load the catalogue right now. Take a look at <a href="{u}">all products</a> or write to us at <a href="mailto:dglaflama@gmail.com">dglaflama@gmail.com</a>.`,
      q_nivel: [`To recommend the right disc, how long have you been playing?`, `Let's do it. First, how long have you been playing disc golf?`],
      op_empezando: `I'm just starting`,
      op_menudo: `I play often`,
      op_compito: `I compete`,
      q_tipo: [`And what type of disc are you looking for?`, `Great. Which disc is missing from your bag?`],
      op_set: `My first discs (a set)`,
      op_putter: `Putter for the basket and short shots`,
      op_mid: `Midrange for mid-range shots`,
      op_driver: `Driver to throw far`,
      q_vuelo: [`How would you like it to fly?`, `Last question: how do you want it to fly?`],
      op_recto: `Straight`,
      op_facil: `Easy to turn over and glide`,
      op_viento: `Handles the wind`,
      op_igual: `Don't mind`,
      r_envio: `We ship to <strong>all of Spain with Correos for €8.50</strong>, including the Balearic Islands, the Canary Islands, Ceuta and Melilla. When your order goes out we'll send you the tracking number.<br><br>If you play at Parc de l'Hostal del Fum (Palau-solità i Plegamans), <strong>pickup is free</strong>: choose it at checkout. <a href="{u}">See shipping</a>`,
      r_recogida: `You can <strong>collect your order for free</strong> at Parc de l'Hostal del Fum (Palau-solità i Plegamans): choose that option at checkout and we'll arrange to meet you. In the Barcelona area we can also hand-deliver it (€8 or €15 depending on the area). <a href="{u}">See shipping</a>`,
      r_devolucion: `You have <strong>14 days</strong> to return your purchase without giving a reason, as long as the disc hasn't been thrown. If you'd prefer a different weight, colour or disc, we'll swap it if we have stock. Write to us at <a href="mailto:dglaflama@gmail.com">dglaflama@gmail.com</a> with your order number. <a href="{u}">See returns</a>`,
      r_club: `With the <strong>Club La Flama</strong> you earn points with every purchase and redeem them for discounts. If your disc golf club joins, you also get €1 off every disc. <a href="{u}">Discover the Club</a>`,
      r_campos: `We have a map of the disc golf courses in Spain, with directions to each one. <a href="{u}">See courses</a>`,
      r_ligas: `In Leagues you'll see the leagues from clubs that are currently running and how to sign up. If you organise one, you can send it to us too. <a href="{u}">See leagues</a>`,
      r_vuelo: `The 4 numbers on a disc are <strong>speed</strong>, <strong>glide</strong>, <strong>turn</strong> (how much it turns over at the start) and <strong>fade</strong> (how much it hooks back at the end). The more negative the turn, the easier it is to throw. <a href="{u}">Read the guide</a>`,
      r_plastico: `The plastic changes the grip, durability and price: soft ones grip better, premium ones last longer and keep their flight. <a href="{u}">Plastics guide</a>`,
      r_peso: `If you're just starting out, a slightly lighter disc (under 170 g) is easier to throw far. Heavier ones handle the wind better. The weight of each disc is on its page.`,
      r_reglas: `Disc golf is played like golf, but throwing discs at a basket. <a href="{u1}">Basic rules</a> · <a href="{u2}">What is disc golf?</a>`,
      r_encamino: `Discs that are on the way are in <a href="{u}">On the way!</a> and you can reserve them. If a disc is sold out, on its page you can ask us to let you know when it's back.`,
      r_descuentos_club: `With the <strong>Club La Flama</strong> you earn points on every purchase and redeem them for discounts from €5 to €20. If your club joins, you also get €1 off every disc. <a href="{u}">Discover the Club</a>`,
      camp_fin: ` (until {f})`,
      camp_ver: ` <a href="{u}">See</a>`,
      d_rebajados: `And right now these products are on sale:`,
      d_xout: `If you're after something cheaper, check out the X-out discs: they have small stamping flaws, fly just the same and cost less.`,
      r_regalo: `For gifts there's the <strong>Regala la Flama</strong> card (from €5), and whoever gets it picks whatever they like. If you'd rather surprise someone, the <strong>Flama Box</strong> mystery boxes make a really cool gift. <a href="{u}">See gift card</a>`,
      d_cajas: `These are the boxes and packs I have right now:`,
      r_tienda: `We're an online shop, but you can <strong>collect your order for free</strong> at Parc de l'Hostal del Fum (Palau-solità i Plegamans): choose that option at checkout and we'll arrange to meet you. Want to try a disc first? Write to us and we'll sort it out.`,
      r_pago: `At checkout you'll see all the available payment methods. If you have any problem paying, write to us at <a href="mailto:dglaflama@gmail.com">dglaflama@gmail.com</a>.`,
      r_contacto: `Write to us whenever you like: <a href="mailto:dglaflama@gmail.com">dglaflama@gmail.com</a> or on Instagram at <a href="https://ig.me/m/discgolf.laflama" target="_blank" rel="noopener">@discgolf.laflama</a>. You can also leave your message here:`,
      p_saludo: `Hi! What are you looking for? You can write things like “putter for wind”, “driver for beginners” or “packs”.`,
      p_gracias: `You're welcome! If you need anything else, I'm here.`,
      par_con: `Discs with a flight similar to the <strong>{n}</strong> ({s}):`,
      par_no: `I don't have that disc in the shop, but I'll find you a similar one. Tell me a bit more:`,
      enc_uno: [`Yes! I've got this:`, `I've got just this:`],
      enc_varios: [`Sure! Look what I've got:`, `Yes, I've got a few things that might suit you:`, `Here, this is what I've got:`],
      enc_agotado: `It's sold out right now, but on its page you can ask us to let you know.`,
      ver_resultados: `See all {k} results`,
      op_no_busco: `That's not what I'm after`,
      op_que_disco: `Which disc do I need?`,
      pide_correo: `Tell us what you're looking for and we'll reply by email:`,
      s_nada_a: [`Oops, I don't have that right now.`, `Hmm, I can't find that in the shop.`],
      s_nada_b: ` I can look for something similar or, if you leave us your email, we'll see if we can get it for you.`,
      op_buscar_parecido: `Look for something similar`,
      op_pedir: `Ask you to get it in`,
      s_pide_correo: `Great, tell us what you're looking for and we'll reply by email:`,
      s_encontrado: `This is what I found:`,
      s_error: `I couldn't search right now. Write to us at <a href="mailto:dglaflama@gmail.com">dglaflama@gmail.com</a> and we'll help you.`,
      m_packs: `Packs and mystery boxes`,
      m_ofertas: `Deals and discounts`,
      m_envios: `Shipping and pickup`,
      m_cambios: `Exchanges and returns`,
      m_club: `Club La Flama`,
      m_hablar: `Talk to us`,
      op_buscar_otro: `Look for another disc`,
      f_viendo: `You're looking at the <strong>{n}</strong> ({s}). {nv}`,
      f_parecido: `With a similar flight I've got these:`,
      h_de_nuevo: [`Hi again! Can I help you with anything else?`, `Shall we carry on? Tell me what else you need.`],
      h_inicio: [`Hi! 👋 I'm L'Espurna and I'll help you find your disc.`, `Hi! Welcome to La Flama 🔥`],
      h_inicio_b: ` I know everything in the shop: ask me about a disc, a brand, a pack or any question, as if you were messaging me on WhatsApp.`,
      h_buscador: `Hi! Let's find your disc.`,
      h_gracias: `Thanks! We've received your message and will reply by email.`
    },

    gl: {
      agotado: `esgotado`,
      dec: `,`,
      precio_fmt: `{n} €`,
      rec_set: `Para comezar recomendoche <strong>un putter, un midrange e un fairway driver</strong>. Con estes tres podes xogar calquera burato:`,
      rec_packs: `Ou leva un pack xa preparado:`,
      rec_mas_primer: `Como escoller o teu primeiro disco`,
      rec_vacio: `Agora mesmo non teño discos con existencias que encaixen{marca}. Mira os <a href="{u}">{n}</a> ou escríbenos e aconsellámoste:`,
      de_marca_vacio: ` de {m}`,
      rec_fairway_principiante: `Se estás comezando, un <strong>fairway driver</strong> levarate máis lonxe ca un driver de distancia, porque necesita menos brazo. `,
      desc_orden: [`tipo`, `vuelo`, `nivel`, `marca`],
      de_marca: `de {m}`,
      vuelo_recto: `rectos`,
      vuelo_facil: `doados de lanzar`,
      vuelo_viento: `que aguantan o vento`,
      nivel_principiante: `para comezar`,
      nivel_intermedio: `para xogadores con experiencia`,
      nivel_avanzado: `para competir`,
      rec_intro: [`Perfecto, estes son os {d} que eu levaría:`, `Recomendoche estes {d}:`, `Mira estes {d}, creo que che van gustar:`],
      rec_ver_todos: `Ver todos os {n}`,
      tipo_putter: `putters`,
      tipo_mid: `midranges`,
      tipo_fairway: `fairway drivers`,
      tipo_distance: `distance drivers`,
      tipo_driver: `drivers`,
      nv_princ: `É un bo disco para comezar.`,
      nv_todos: `Serve para todos os niveis.`,
      nv_avanz: `Rinde mellor con experiencia e brazo.`,
      nv_avanz2: `É mellor para xogadores con experiencia e brazo.`,
      info_precio: `Podes ter o <strong>{n}</strong> desde <strong>{p}</strong>{fin} `,
      segun_plastico: `, segundo o plástico.`,
      info_si: `Si! Teño o <strong>{n}</strong>. `,
      info_agotado: `O <strong>{n}</strong> agora mesmo está esgotado. `,
      info_vuela_n: `O <strong>{n}</strong> voa `,
      info_vuela: `Voa `,
      versiones: `Téñoo en {k} versións:`,
      lo_tengo: `Téñoo aquí:`,
      agotado_aviso: `Agora mesmo está esgotado. Na súa ficha podes pedir que che avisemos:`,
      op_compara: `Con que se compara?`,
      op_parecidos: `Discos parecidos`,
      op_otra: `Outra pregunta`,
      parecido_a: `Cun voo parecido ao {n} teño estes:`,
      otra_a: [`Dime, que máis precisas?`, `Pregúntame o que sexa.`],
      otra_b: [`Dime, que máis precisas?`, `Claro, escríbeme abaixo o que queiras.`, `Pregúntame o que sexa.`],
      cmp_rapido: `O <strong>{a}</strong> é máis rápido (speed {x} fronte a {y}), así que necesita máis brazo para voar ben.`,
      cmp_estable: `O <strong>{a}</strong> é máis estable: aguanta mellor o vento e pecha máis ao final. O <strong>{b}</strong> é máis doado de lanzar e tende a ir máis recto ou a xirar.`,
      cmp_planea: `O <strong>{a}</strong> planea máis, ideal para gañar metros sen forzar.`,
      cmp_igual: `Voan de forma moi parecida. A diferenza está sobre todo no plástico e no tacto na man.`,
      cmp_cab: `{a} ({x}) fronte a {b} ({y}):<br><br>`,
      pl_con_marca: `O <strong>{n}</strong> é un plástico de {m}. `,
      pl_sin_marca: `O <strong>{n}</strong>. `,
      pl_familia: `<br><br>Desta familia teño: {l}.`,
      pl_discos: `Algúns discos en {n}:`,
      err_catalogo: `Non puiden cargar o catálogo agora. Mira <a href="{u}">todos os produtos</a> ou escríbenos a <a href="mailto:dglaflama@gmail.com">dglaflama@gmail.com</a>.`,
      q_nivel: [`Para recomendarche ben, canto tempo levas xogando?`, `Imos a iso. Primeiro, canto levas xogando ao disc golf?`],
      op_empezando: `Estou comezando`,
      op_menudo: `Xogo a miúdo`,
      op_compito: `Competo`,
      q_tipo: [`E que tipo de disco buscas?`, `Xenial. Que disco che falta na bolsa?`],
      op_set: `Os meus primeiros discos (un set)`,
      op_putter: `Putter para a cesta e tiros curtos`,
      op_mid: `Midrange para tiros medios`,
      op_driver: `Driver para sacar lonxe`,
      q_vuelo: [`Como che gustaría que voase?`, `Última pregunta: como queres que voe?`],
      op_recto: `Recto`,
      op_facil: `Que se abra fácil e planee`,
      op_viento: `Que aguante o vento`,
      op_igual: `Tanto me ten`,
      r_envio: `Enviamos a <strong>toda España con Correos por 8,50 €</strong>, tamén a Baleares, Canarias, Ceuta e Melilla. Cando sae o teu pedido mandámosche o número de seguimento.<br><br>Se xogas no Parc de l'Hostal del Fum (Palau-solità i Plegamans), a <strong>recollida é gratuíta</strong>: escóllea ao pagar. <a href="{u}">Ver envíos</a>`,
      r_recogida: `Podes <strong>recoller gratis</strong> o teu pedido no Parc de l'Hostal del Fum (Palau-solità i Plegamans): escolle esa opción ao pagar e quedamos contigo. Na zona de Barcelona tamén cho levamos en man (8 € ou 15 € segundo a zona). <a href="{u}">Ver envíos</a>`,
      r_devolucion: `Tes <strong>14 días</strong> para devolver a túa compra sen dar motivos, co disco sen lanzar. Se prefires outro peso, cor ou disco, cambiámoscho se hai existencias. Escríbenos a <a href="mailto:dglaflama@gmail.com">dglaflama@gmail.com</a> co teu número de pedido. <a href="{u}">Ver devolucións</a>`,
      r_club: `Co <strong>Club La Flama</strong> sumas puntos con cada compra e trócalos por descontos. Se o teu club de disc golf se une, ademais tes 1 € de desconto en cada disco. <a href="{u}">Coñece o Club</a>`,
      r_campos: `Temos un mapa cos campos de disc golf de España, con como chegar a cada un. <a href="{u}">Ver campos</a>`,
      r_ligas: `En Ligas verás as ligas dos clubs que están en marcha e como apuntarte. Se organizas unha, tamén podes enviárnola. <a href="{u}">Ver ligas</a>`,
      r_vuelo: `Os 4 números dun disco son <strong>speed</strong> (velocidade), <strong>glide</strong> (planeo), <strong>turn</strong> (canto se abre ao principio) e <strong>fade</strong> (canto pecha ao final). Canto máis negativo o turn, máis doado de lanzar. <a href="{u}">Ler a guía</a>`,
      r_plastico: `O plástico cambia o agarre, a durabilidade e o prezo: os brandos agarran mellor, os premium duran máis e manteñen o voo. <a href="{u}">Guía de plásticos</a>`,
      r_peso: `Se estás comezando, un disco algo máis lixeiro (por debaixo de 170 g) é máis doado de lanzar lonxe. Os máis pesados aguantan mellor o vento. O peso de cada disco está na súa ficha.`,
      r_reglas: `O disc golf xógase como o golf, pero lanzando discos a unha cesta. <a href="{u1}">Regras básicas</a> · <a href="{u2}">Que é o disc golf?</a>`,
      r_encamino: `Os discos que están de camiño están en <a href="{u}">En camiño!</a> e podes reservalos. Se un disco está esgotado, na súa ficha podes pedir que che avisemos cando volva.`,
      r_descuentos_club: `Co <strong>Club La Flama</strong> sumas puntos en cada compra e trócalos por descontos de 5 € a 20 €. Se o teu club se une, tes ademais 1 € de desconto en cada disco. <a href="{u}">Coñece o Club</a>`,
      camp_fin: ` (ata o {f})`,
      camp_ver: ` <a href="{u}">Ver</a>`,
      d_rebajados: `E agora mesmo tes estes produtos rebaixados:`,
      d_xout: `Se buscas algo máis económico, mira os discos X-out: son discos con pequenos defectos de estampado, que voan igual e custan menos.`,
      r_regalo: `Para regalar tes a tarxeta <strong>Regala la Flama</strong> (desde 5 €), e quen a recibe escolle o que queira. Se prefires sorprender, as caixas sorpresa <strong>Flama Box</strong> son un regalo moi chulo. <a href="{u}">Ver tarxeta de agasallo</a>`,
      d_cajas: `Estas son as caixas e packs que teño agora:`,
      r_tienda: `Somos unha tenda online, pero podes <strong>recoller o teu pedido gratis</strong> no Parc de l'Hostal del Fum (Palau-solità i Plegamans): escolle esa opción ao pagar e quedamos contigo. Queres probar un disco antes? Escríbenos e falámolo.`,
      r_pago: `Ao finalizar a compra verás todas as formas de pagamento dispoñibles. Se tes calquera problema ao pagar, escríbenos a <a href="mailto:dglaflama@gmail.com">dglaflama@gmail.com</a>.`,
      r_contacto: `Escríbenos cando queiras: <a href="mailto:dglaflama@gmail.com">dglaflama@gmail.com</a> ou por Instagram en <a href="https://ig.me/m/discgolf.laflama" target="_blank" rel="noopener">@discgolf.laflama</a>. Tamén podes deixarnos a túa mensaxe aquí:`,
      p_saludo: `Ola! Que estás a buscar? Podes escribirme cousas como «putter para vento», «driver para comezar» ou «packs».`,
      p_gracias: `A ti! Se precisas algo máis, aquí estou.`,
      par_con: `Discos cun voo parecido ao <strong>{n}</strong> ({s}):`,
      par_no: `Ese disco non o teño na tenda, pero búscoche un parecido. Cóntame un pouco:`,
      enc_uno: [`Si! Teño isto:`, `Teño xusto isto:`],
      enc_varios: [`Claro! Mira o que teño:`, `Si, teño varias cousas que che poden encaixar:`, `Mira, isto é o que teño:`],
      enc_agotado: `Agora mesmo está esgotado, pero na ficha podes pedir que che avisemos.`,
      ver_resultados: `Ver os {k} resultados`,
      op_no_busco: `Non é o que busco`,
      op_que_disco: `Que disco necesito?`,
      pide_correo: `Cóntanos que buscas e respondémosche por correo:`,
      s_nada_a: [`Vaia, iso non o teño agora mesmo.`, `Uf, iso non o atopo na tenda.`],
      s_nada_b: ` Podo buscarche algo parecido ou, se nos deixas o teu correo, miramos se podemos conseguilo.`,
      op_buscar_parecido: `Buscar algo parecido`,
      op_pedir: `Pedir que o consigades`,
      s_pide_correo: `Xenial, dinos que buscas e respondémosche por correo:`,
      s_encontrado: `Isto é o que atopei:`,
      s_error: `Non puiden buscar agora. Escríbenos a <a href="mailto:dglaflama@gmail.com">dglaflama@gmail.com</a> e axudámoste.`,
      m_packs: `Packs e caixas sorpresa`,
      m_ofertas: `Ofertas e descontos`,
      m_envios: `Envíos e recollida`,
      m_cambios: `Cambios e devolucións`,
      m_club: `Club La Flama`,
      m_hablar: `Falar connosco`,
      op_buscar_otro: `Buscar outro disco`,
      f_viendo: `Estás vendo o <strong>{n}</strong> ({s}). {nv}`,
      f_parecido: `Cun voo parecido teño estes:`,
      h_de_nuevo: [`Ola de novo! Axúdote con algo máis?`, `Seguimos? Dime que máis precisas.`],
      h_inicio: [`Ola! 👋 Son L'Espurna e axúdote a atopar o teu disco.`, `Ola! Dámosche a benvida a La Flama 🔥`],
      h_inicio_b: ` Coñezo todo o que hai na tenda: pregúntame por un disco, unha marca, un pack ou calquera dúbida, coma se me escribises por WhatsApp.`,
      h_buscador: `Ola! Imos atopar o teu disco.`,
      h_gracias: `Grazas! Recibimos a túa mensaxe e responderémosche por correo.`
    },

    eu: {
      agotado: `agortuta`,
      dec: `,`,
      precio_fmt: `{n} €`,
      rec_set: `Hasteko <strong>putter bat, midrange bat eta fairway driver bat</strong> gomendatzen dizkizut. Hiru hauekin edozein zulo jokatu dezakezu:`,
      rec_packs: `Edo eraman prest dagoen pack bat:`,
      rec_mas_primer: `Nola aukeratu zure lehen diskoa`,
      rec_vacio: `Oraintxe ez daukat zure eskaerara egokitzen den diskorik stockean{marca}. Begiratu <a href="{u}">{n}</a> edo idatzi iezaguzu eta aholkatuko dizugu:`,
      de_marca_vacio: ` ({m} marka)`,
      rec_fairway_principiante: `Hasi berria bazara, <strong>fairway driver</strong> batek distance driver batek baino urrunago eramango zaitu, beso gutxiago behar baitu. `,
      desc_orden: [`marca`, `nivel`, `tipo`, `vuelo`],
      de_marca: `{m} markako`,
      vuelo_recto: `zuzenak`,
      vuelo_facil: `jaurtitzeko errazak`,
      vuelo_viento: `haizeari eusten diotenak`,
      nivel_principiante: `hasteko`,
      nivel_intermedio: `esperientzia duten jokalarientzako`,
      nivel_avanzado: `lehiatzeko`,
      rec_intro: [`Primeran, hauek dira nik hartuko nituzkeen {d}:`, `Honako {d} gomendatzen dizkizut:`, `Honako {d} ikusi ditzakezu, uste dut gustatuko zaizkizula:`],
      rec_ver_todos: `Ikusi {n} guztiak`,
      tipo_putter: `putter`,
      tipo_mid: `midrange`,
      tipo_fairway: `fairway driver`,
      tipo_distance: `distance driver`,
      tipo_driver: `driver`,
      nv_princ: `Disko ona da hasteko.`,
      nv_todos: `Maila guztietarako balio du.`,
      nv_avanz: `Hobeto funtzionatzen du esperientzia eta beso indarra daukanarentzat.`,
      nv_avanz2: `Esperientzia eta beso indarra duten jokalarientzat egokiagoa da.`,
      info_precio: `<strong>{n}</strong> diskoa <strong>{p}</strong>-tik aurrera duzu{fin} `,
      segun_plastico: `, plastikoaren arabera.`,
      info_si: `Bai! <strong>{n}</strong> badaukat. `,
      info_agotado: `<strong>{n}</strong> agortuta dago oraintxe. `,
      info_vuela_n: `<strong>{n}</strong> diskoaren hegaldia: `,
      info_vuela: `Hegaldia: `,
      versiones: `{k} bertsiotan daukat:`,
      lo_tengo: `Hemen daukat:`,
      agotado_aviso: `Oraintxe agortuta dago. Bere fitxan abisatzeko eska dezakezu:`,
      op_compara: `Zerekin alderatzen da?`,
      op_parecidos: `Antzeko diskoak`,
      op_otra: `Beste galdera bat`,
      parecido_a: `{n} diskoaren antzeko hegaldia dutenak hauek ditut:`,
      otra_a: [`Esan, zer gehiago behar duzu?`, `Galdetu nahi duzuna.`],
      otra_b: [`Esan, zer gehiago behar duzu?`, `Noski, idatzi behean nahi duzuna.`, `Galdetu nahi duzuna.`],
      cmp_rapido: `<strong>{a}</strong> bizkorragoa da (speed {x} vs {y}), beraz beso gehiago behar du ondo hegan egiteko.`,
      cmp_estable: `<strong>{a}</strong> egonkorragoa da: haizeari hobeto eusten dio eta amaieran gehiago ixten du. <strong>{b}</strong> jaurtitzeko errazagoa da, eta zuzenago joateko edo biratzeko joera du.`,
      cmp_planea: `<strong>{a}</strong> gehiago planeatzen du, metroak indarrik egin gabe irabazteko aproposa.`,
      cmp_igual: `Oso antzera hegan egiten dute. Aldea batez ere plastikoan eta eskuko sentsazioan dago.`,
      cmp_cab: `{a} ({x}) vs {b} ({y}):<br><br>`,
      pl_con_marca: `<strong>{n}</strong> {m} markako plastikoa da. `,
      pl_sin_marca: `<strong>{n}</strong>. `,
      pl_familia: `<br><br>Familia honetakoak ditut: {l}.`,
      pl_discos: `{n} plastikoko disko batzuk:`,
      err_catalogo: `Ezin izan dut katalogoa kargatu oraintxe. Begiratu <a href="{u}">produktu guztiak</a> edo idatzi iezaguzu helbide honetara: <a href="mailto:dglaflama@gmail.com">dglaflama@gmail.com</a>.`,
      q_nivel: [`Ondo gomendatzeko, zenbat denbora daramazu jokatzen?`, `Goazen. Lehenik, zenbat denbora daramazu disc golfean jokatzen?`],
      op_empezando: `Hasi berria naiz`,
      op_menudo: `Sarri jokatzen dut`,
      op_compito: `Lehiatzen naiz`,
      q_tipo: [`Eta zer disko mota bilatzen duzu?`, `Primeran. Zer disko falta zaizu poltsan?`],
      op_set: `Nire lehen diskoak (set bat)`,
      op_putter: `Putterra saskirako eta tiro laburretarako`,
      op_mid: `Midrangea tarteko tiroetarako`,
      op_driver: `Driverra urrun jaurtitzeko`,
      q_vuelo: [`Nola gustatuko litzaizuke hegan egitea?`, `Azken galdera: nola nahi duzu hegan egitea?`],
      op_recto: `Zuzena`,
      op_facil: `Erraz irekitzen dena eta planeatzen duena`,
      op_viento: `Haizeari eusten diona`,
      op_igual: `Berdin zait`,
      r_envio: `Espainia osora bidaltzen dugu <strong>Correosekin 8,50 €-ren truke</strong>, baita Balearretara, Kanarietara, Ceutara eta Melillara ere. Zure eskaera irtetean jarraipen-zenbakia bidaliko dizugu.<br><br>Parc de l'Hostal del Fum-en (Palau-solità i Plegamans) jokatzen baduzu, <strong>jasotzea doakoa da</strong>: aukeratu ordaintzean. <a href="{u}">Ikusi bidalketak</a>`,
      r_recogida: `Zure eskaera <strong>doan jaso</strong> dezakezu Parc de l'Hostal del Fum-en (Palau-solità i Plegamans): aukeratu aukera hori ordaintzean eta zurekin geratuko gara. Bartzelonaren inguruan eskuz esku ere eramaten dizugu (8 € edo 15 €, eremuaren arabera). <a href="{u}">Ikusi bidalketak</a>`,
      r_devolucion: `<strong>14 egun</strong> dituzu erosketa itzultzeko, arrazoirik eman gabe, diskoa jaurti gabe badago. Beste pisu, kolore edo disko bat nahi baduzu, aldatuko dizugu stocka badago. Idatzi iezaguzu helbide honetara: <a href="mailto:dglaflama@gmail.com">dglaflama@gmail.com</a>, zure eskaera-zenbakiarekin. <a href="{u}">Ikusi itzulketak</a>`,
      r_club: `<strong>Club La Flama</strong>-rekin puntuak batzen dituzu erosketa bakoitzean eta deskontuengatik trukatzen dituzu. Zure disc golf klubak bat egiten badu, gainera 1 €-ko deskontua duzu disko bakoitzean. <a href="{u}">Ezagutu Kluba</a>`,
      r_campos: `Espainiako disc golf zelaien mapa dugu, bakoitzera nola iritsi azalduta. <a href="{u}">Ikusi zelaiak</a>`,
      r_ligas: `Ligak atalean martxan dauden klubetako ligak ikusiko dituzu eta nola eman izena. Bat antolatzen baduzu, guri bidal diezaguzu ere. <a href="{u}">Ikusi ligak</a>`,
      r_vuelo: `Disko baten 4 zenbakiak <strong>speed</strong> (abiadura), <strong>glide</strong> (planeoa), <strong>turn</strong> (hasieran zenbat irekitzen den) eta <strong>fade</strong> (amaieran zenbat ixten den) dira. Turna zenbat eta negatiboagoa, orduan eta errazagoa jaurtitzeko. <a href="{u}">Irakurri gida</a>`,
      r_plastico: `Plastikoak heldulekua, iraunkortasuna eta prezioa aldatzen ditu: bigunek hobeto heltzen diote, premiumek gehiago irauten dute eta hegaldia mantentzen dute. <a href="{u}">Plastikoen gida</a>`,
      r_peso: `Hasi berria bazara, pixka bat arinagoa den disko bat (170 g-tik behera) errazagoa da urrun jaurtitzeko. Astunagoek haizeari hobeto eusten diote. Disko bakoitzaren pisua bere fitxan dago.`,
      r_reglas: `Disc golfa golfa bezala jokatzen da, baina diskoak saski batera jaurtiz. <a href="{u1}">Oinarrizko arauak</a> · <a href="{u2}">Zer da disc golfa?</a>`,
      r_encamino: `Bidean dauden diskoak <a href="{u}">Bidean!</a> atalean daude eta erreserba ditzakezu. Disko bat agortuta badago, bere fitxan abisatzeko eska dezakezu berriro iristen denean.`,
      r_descuentos_club: `<strong>Club La Flama</strong>-rekin puntuak batzen dituzu erosketa bakoitzean eta 5 €-tik 20 €-ra bitarteko deskontuengatik trukatzen dituzu. Zure klubak bat egiten badu, gainera 1 €-ko deskontua duzu disko bakoitzean. <a href="{u}">Ezagutu Kluba</a>`,
      camp_fin: ` ({f} arte)`,
      camp_ver: ` <a href="{u}">Ikusi</a>`,
      d_rebajados: `Eta oraintxe produktu hauek dituzu prezio jaitsieran:`,
      d_xout: `Zerbait merkeagoa bilatzen baduzu, begiratu X-out diskoei: zigilatze-akats txikiak dituzten diskoak dira, berdin hegan egiten dute eta merkeagoak dira.`,
      r_regalo: `Oparitzeko <strong>Regala la Flama</strong> txartela duzu (5 €-tik aurrera), eta jasotzen duenak nahi duena aukeratzen du. Sorpresa eman nahi baduzu, <strong>Flama Box</strong> sorpresa-kutxak opari oso polita dira. <a href="{u}">Ikusi opari-txartela</a>`,
      d_cajas: `Hauek dira oraintxe ditudan kutxak eta packak:`,
      r_tienda: `Online denda gara, baina zure eskaera <strong>doan jaso</strong> dezakezu Parc de l'Hostal del Fum-en (Palau-solità i Plegamans): aukeratu aukera hori ordaintzean eta zurekin geratuko gara. Diskoren bat aurretik probatu nahi duzu? Idatzi iezaguzu eta hitz egingo dugu.`,
      r_pago: `Erosketa amaitzean eskuragarri dauden ordainbide guztiak ikusiko dituzu. Ordaintzean arazorik baduzu, idatzi iezaguzu helbide honetara: <a href="mailto:dglaflama@gmail.com">dglaflama@gmail.com</a>.`,
      r_contacto: `Idatzi iezaguzu nahi duzunean: <a href="mailto:dglaflama@gmail.com">dglaflama@gmail.com</a> edo Instagramen <a href="https://ig.me/m/discgolf.laflama" target="_blank" rel="noopener">@discgolf.laflama</a>. Hemen ere utz diezaguzu zure mezua:`,
      p_saludo: `Kaixo! Zer bilatzen duzu? Honelako gauzak idatz diezazkidazu: «haizerako putterra», «hasteko driverra» edo «packak».`,
      p_gracias: `Zuri! Beste zerbait behar baduzu, hemen nago.`,
      par_con: `<strong>{n}</strong> diskoaren antzeko hegaldia duten diskoak ({s}):`,
      par_no: `Disko hori ez daukat dendan, baina antzeko bat bilatuko dizut. Kontatu pixka bat:`,
      enc_uno: [`Bai! Hau daukat:`, `Hau bera daukat:`],
      enc_varios: [`Noski! Begira zer daukadan:`, `Bai, zuri egokitu dakizkizukeen hainbat gauza ditut:`, `Begira, hau da daukadana:`],
      enc_agotado: `Oraintxe agortuta dago, baina fitxan abisatzeko eska dezakezu.`,
      ver_resultados: `Ikusi {k} emaitzak`,
      op_no_busco: `Ez da bilatzen dudana`,
      op_que_disco: `Zer disko behar dut?`,
      pide_correo: `Kontatu zer bilatzen duzun eta posta elektronikoz erantzungo dizugu:`,
      s_nada_a: [`Ene, hori ez daukat oraintxe.`, `Ufa, hori ez dut dendan aurkitzen.`],
      s_nada_b: ` Antzeko zerbait bila diezazuket edo, zure posta elektronikoa uzten badiguzu, begiratuko dugu lortu dezakegun.`,
      op_buscar_parecido: `Antzeko zerbait bilatu`,
      op_pedir: `Eskatu lor dezazuela`,
      s_pide_correo: `Primeran, esan zer bilatzen duzun eta posta elektronikoz erantzungo dizugu:`,
      s_encontrado: `Hau da aurkitu dudana:`,
      s_error: `Ezin izan dut bilatu oraintxe. Idatzi iezaguzu helbide honetara: <a href="mailto:dglaflama@gmail.com">dglaflama@gmail.com</a>, eta lagunduko dizugu.`,
      m_packs: `Packak eta sorpresa-kutxak`,
      m_ofertas: `Eskaintzak eta deskontuak`,
      m_envios: `Bidalketak eta jasotzea`,
      m_cambios: `Aldaketak eta itzulketak`,
      m_club: `Club La Flama`,
      m_hablar: `Gurekin hitz egin`,
      op_buscar_otro: `Beste disko bat bilatu`,
      f_viendo: `<strong>{n}</strong> diskoa ikusten ari zara ({s}). {nv}`,
      f_parecido: `Antzeko hegaldia dutenak hauek ditut:`,
      h_de_nuevo: [`Kaixo berriro! Zerbaitetan lagun zaitzaket?`, `Jarraitzen dugu? Esan zer gehiago behar duzun.`],
      h_inicio: [`Kaixo! 👋 L'Espurna naiz, La Flamaren laguntzailea.`, `Kaixo! Ongi etorri La Flamara 🔥`],
      h_inicio_b: ` Dendan dagoen guztia ezagutzen dut: galdetu iezadazu disko bati, marka bati, pack bati edo edozein zalantzari buruz, WhatsAppez idatziko bazenit bezala.`,
      h_buscador: `Kaixo! Goazen zure diskoa aurkitzera.`,
      h_gracias: `Eskerrik asko! Zure mezua jaso dugu eta posta elektronikoz erantzungo dizugu.`
    }
  };
  /* ==/TXT== */
  /* tx(clave, datos): texto del idioma activo (si falta, el castellano). {x} se sustituye por datos.x */
  function tx(clave, datos) {
    var v = TXT[IDIOMA][clave];
    if (v == null) v = TXT.es[clave];
    if (v == null) return clave;
    var sub = function (s) {
      return datos ? s.replace(/\{(\w+)\}/g, function (m, c) { return datos[c] != null ? datos[c] : m; }) : s;
    };
    return Array.isArray(v) ? v.map(sub) : sub(v);
  }

  /* ---------- Utilidades ---------- */
  function guardar(clave, valor) { try { localStorage.setItem(clave, valor); } catch (e) {} }
  function leer(clave) { try { return localStorage.getItem(clave); } catch (e) { return null; } }
  function normal(t) { return (t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9ñ€.,\s-]/g, ' ').replace(/\s+/g, ' ').trim(); }
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML.replace(/"/g, '&quot;'); }
  function url(ruta) { return RAIZ_URL.replace(/\/$/, '') + ruta; }
  function contiene(texto, lista_claves) { return lista_claves.some(function (k) { return texto.indexOf(k) !== -1; }); }
  function una(frases) { return frases[Math.floor(Math.random() * frases.length)]; }
  function raizPalabra(p) { return p.length > 4 ? p.replace(/(es|s)$/, '') : p; }
  function dinero(n) { return tx('precio_fmt', { n: n.toFixed(2).replace('.', tx('dec')) }); }

  /* ---------- Palabras clave (todas ya normalizadas como normal(): minúsculas, sin acentos) ---------- */
  /* Ojo: normal() convierte ñ en n y ç en c, y el punto medio de "l·l" en un espacio ("col·lecció" = "col leccio").
     Por eso aquí no hay ñ, ç ni "·". Las listas de los 5 idiomas se unen siempre (kw). */
  function W(s) { return s.split(' '); }
  /* ==KW== */
  var KW = {
    vacias: {
      es: ('hay algun alguno alguna algunos algo un una unos unas el la los las lo le de del que q tienes teneis tienen tiene ' +
        'tengo busco buscando buscaba quiero queria quisiera necesito me mi mis para por con sin en y o a al es son se hola buenas ' +
        'gracias favor porfa puedo podeis puedes vendeis venden disponible disponibles cual cuales como mas muy este esta esto eso ' +
        'ese ver saber info informacion os nos tu su sus dame ensename mostrar muestrame recomiendas recomendais recomienda bueno buena ' +
        'mejor mejores tipo ser estoy soy si no ya otro otra hacer haceis').split(' '),
      ca: W('hi ha algun alguna alguns algunes uns unes els les li dels tens teniu tenen tinc buscant buscava vull volia voldria necessito em meu meva meus meves ' +
        'sense i al als hola bones gracies us plau puc podeu pots venen vengueu quin quina quins quines com mes molt aquest aquesta aixo allo ' +
        'veure informacio teu seva ensenya mostra recomanes recomaneu recomana bo bona bon millor millors tipus estic soc ja altre altra fer feu tots totes tot'),
      en: W('the an is are am be been was were do does did you your yours my we our it its this that these those there here have has had got any some anything something ' +
        'what which who whom how where when why much many more most very can could would should will please thanks thank hello hi hey hiya want wanted need needs ' +
        'looking look looks searching search show give tell find see know about for of to in on at by with without from into and or but if so as also just really ' +
        'best good great nice better one ones kind type types sell sells selling available get buy like don doesn didn isn aren won ll re ve yes disc discs'),
      gl: W('hai algunha alguns algunhas unha uns unhas os lle do da dos das tes tedes ten tenen teno quero quisera preciso necesito meu meus ' +
        'sen ou ao aos ola boas bos grazas podo podedes vendedes cal cales mais moi isto iso aquel informacion ensiname mostrame recomendades ' +
        'boa mellor mellores estou non xa facer facedes tamen dias tardes noites'),
      eu: W('bat batzuk zer zein zeintzuk nola non noiz zenbat da dira du dute dut dugu duzu duzue ditut dituzu dituzue ditugu daukat daukazu daukazue dauka daukate ' +
        'badaukazue badituzue badago badaude ba eta edo ez bai nahi nahiko behar nire zure gure hau hori hura hauek horiek nik zuk guk zuek ni zu gu hemen han oso ' +
        'gehiago ere mesedez eskerrik asko kaixo agur egun on arratsalde gabon bila bilatzen bilatu ikusi jakin erakutsi eman gomendatu gomendatzen onena onenak hobe hobea ' +
        'bezala izan naiz gara zara zarete dago daude dezaket dezakezu dezakezue saltzen dauden dagoen disko diskoa diskoak diskoen')
    },
    sinonimos: {
      es: {
        set: ['pack', 'kit', 'lote', 'box', 'caja'],
        pack: ['set', 'kit', 'box', 'caja'],
        kit: ['pack', 'set'],
        lote: ['pack', 'set'],
        caja: ['box', 'pack'],
        sorpresa: ['mystery', 'box'],
        misterio: ['mystery', 'box'],
        personalizado: ['seleccion', 'medida', 'tenir', 'blanco', 'flames'],
        personaliza: ['seleccion', 'medida', 'tenir', 'blanco', 'flames'],
        custom: ['personalizado', 'seleccion', 'tenir'],
        tenir: ['blanco', 'dye'],
        regalo: ['regala', 'tarjeta'],
        bolsa: ['mochila', 'bag'],
        mochila: ['bolsa', 'bag'],
        cesta: ['canasta', 'basket'],
        recuperador: ['retriever'],
        rescatar: ['retriever'],
        agua: ['retriever', 'flota'],
        toalla: ['towel'],
        botella: ['bottle'],
        marcador: ['mini'],
        luminoso: ['glow'],
        brilla: ['glow'],
        oscuridad: ['glow'],
        noche: ['glow'],
        transparente: ['clear', 'ice', 'eclipse'],
        blando: ['soft', 'g7', 'rubber'],
        duro: ['hard', 'h9'],
        nuevo: ['nuevo'],
        novedad: ['nuevo'],
        novedades: ['nuevo']
      },
      ca: {
        lot: ['pack', 'set', 'lote'],
        caixa: ['box', 'pack', 'caja'],
        misteri: ['mystery', 'box'],
        personalitzat: ['seleccion', 'medida', 'tenir', 'blanco', 'flames', 'personalizado'],
        personalitzada: ['seleccion', 'medida', 'tenir', 'blanco', 'flames', 'personalizado'],
        personalitza: ['seleccion', 'medida', 'tenir', 'blanco', 'flames', 'personalizado'],
        tenyir: ['blanco', 'dye', 'tenir'],
        regal: ['regala', 'tarjeta', 'targeta', 'gift'],
        bossa: ['mochila', 'bag', 'bolsa'],
        motxilla: ['bolsa', 'bag', 'mochila'],
        cistella: ['canasta', 'basket', 'cesta'],
        recuperar: ['retriever'],
        aigua: ['retriever', 'flota', 'agua'],
        tovallola: ['towel', 'toalla'],
        ampolla: ['bottle', 'botella'],
        lluminos: ['glow'],
        foscor: ['glow'],
        nit: ['glow'],
        transparent: ['clear', 'ice', 'eclipse'],
        tou: ['soft', 'g7', 'rubber', 'blando'],
        dur: ['hard', 'h9', 'duro'],
        nou: ['nuevo'],
        nova: ['nuevo'],
        novetat: ['nuevo'],
        novetats: ['nuevo']
      },
      en: {
        bundle: ['pack', 'set', 'lote'],
        box: ['caja', 'pack', 'mystery'],
        mystery: ['sorpresa', 'box'],
        surprise: ['mystery', 'box', 'sorpresa'],
        customised: ['seleccion', 'medida', 'tenir', 'blanco', 'flames', 'personalizado'],
        customized: ['seleccion', 'medida', 'tenir', 'blanco', 'flames', 'personalizado'],
        personalised: ['seleccion', 'medida', 'tenir', 'blanco', 'flames', 'personalizado'],
        personalized: ['seleccion', 'medida', 'tenir', 'blanco', 'flames', 'personalizado'],
        dye: ['blanco', 'tenir'],
        gift: ['regala', 'tarjeta', 'regalo'],
        voucher: ['regala', 'tarjeta'],
        card: ['tarjeta'],
        bag: ['mochila', 'bolsa'],
        backpack: ['mochila', 'bag', 'bolsa'],
        basket: ['canasta', 'cesta'],
        water: ['retriever', 'flota', 'agua'],
        floating: ['retriever', 'flota'],
        rescue: ['retriever'],
        towel: ['toalla'],
        bottle: ['botella'],
        marker: ['mini', 'marcador'],
        glowing: ['glow'],
        luminous: ['glow'],
        dark: ['glow'],
        night: ['glow'],
        translucent: ['clear', 'ice', 'eclipse'],
        soft: ['g7', 'rubber', 'blando'],
        squishy: ['soft', 'g7', 'rubber', 'blando'],
        hard: ['h9', 'duro'],
        new: ['nuevo'],
        newest: ['nuevo'],
        latest: ['nuevo'],
        arrivals: ['nuevo']
      },
      gl: {
        caixa: ['box', 'pack', 'caja'],
        personalizada: ['seleccion', 'medida', 'tenir', 'blanco', 'flames', 'personalizado'],
        tinguir: ['blanco', 'dye', 'tenir'],
        agasallo: ['regala', 'tarjeta', 'regalo'],
        tarxeta: ['regala', 'tarjeta'],
        auga: ['retriever', 'flota', 'agua'],
        escuridade: ['glow'],
        noite: ['glow'],
        brando: ['soft', 'g7', 'rubber', 'blando'],
        novo: ['nuevo'],
        nova: ['nuevo'],
        novidade: ['nuevo'],
        novidades: ['nuevo']
      },
      eu: {
        multzo: ['pack', 'set'],
        paketea: ['pack', 'set', 'box'],
        kutxa: ['box', 'pack', 'caja'],
        sorpresazko: ['mystery', 'box', 'sorpresa'],
        pertsonalizatu: ['seleccion', 'medida', 'tenir', 'blanco', 'flames', 'personalizado'],
        pertsonalizatua: ['seleccion', 'medida', 'tenir', 'blanco', 'flames', 'personalizado'],
        pertsonalizatuak: ['seleccion', 'medida', 'tenir', 'blanco', 'flames', 'personalizado'],
        margotu: ['blanco', 'dye', 'tenir'],
        opari: ['regala', 'tarjeta', 'regalo'],
        oparia: ['regala', 'tarjeta', 'regalo'],
        opariak: ['regala', 'tarjeta', 'regalo'],
        poltsa: ['mochila', 'bag', 'bolsa'],
        motxila: ['bolsa', 'bag', 'mochila'],
        saski: ['canasta', 'basket', 'cesta'],
        saskia: ['canasta', 'basket', 'cesta'],
        berreskuratzaile: ['retriever'],
        ura: ['retriever', 'flota', 'agua'],
        eskuoihal: ['towel', 'toalla'],
        botila: ['bottle', 'botella'],
        markatzaile: ['mini', 'marcador'],
        iluntasun: ['glow'],
        gau: ['glow'],
        gardena: ['clear', 'ice', 'eclipse'],
        garden: ['clear', 'ice', 'eclipse'],
        biguna: ['soft', 'g7', 'rubber', 'blando'],
        bigun: ['soft', 'g7', 'rubber', 'blando'],
        gogorra: ['hard', 'h9', 'duro'],
        gogor: ['hard', 'h9', 'duro'],
        berria: ['nuevo'],
        berri: ['nuevo'],
        berritasunak: ['nuevo'],
        berritasun: ['nuevo']
      }
    },
    genericas: {
      es: ['disco', 'discos', 'golf', 'disc', 'jugar', 'juego'],
      ca: ['joc', 'jocs'],
      en: ['discs', 'play', 'playing', 'game'],
      gl: ['xogar', 'xogo', 'xogos'],
      eu: ['disko', 'diskoa', 'diskoak', 'jokatu', 'joko']
    },
    /* Señales de tipo: la primera familia que coincida gana (fairway, putter, mid, driver). Se busca como subcadena sobre " texto " */
    s_tipo_fairway: {
      es: ['fairway', 'fairways', 'control'],
      eu: ['kontrol']
    },
    s_tipo_putter: {
      es: ['putter', 'putters', 'putt', 'approach', 'aproach', 'cesta'],
      ca: ['cistella', 'curta distancia', 'distancia curta', 'tirs curts'],
      en: ['basket', 'short distance', 'short shots', 'close range'],
      gl: ['curta distancia', 'distancia curta', 'tiros curtos'],
      eu: ['saski', 'distantzia motz', 'tiro labur']
    },
    s_tipo_mid: {
      es: ['midrange', 'midranges', 'mid ', 'medio', 'medios', 'media distancia'],
      ca: ['mid-', ' mig ', 'mitja distancia', 'mitjana distancia', 'distancia mitja', 'distancia mitjana', 'distancies mitjanes', 'tirs mitjans'],
      en: ['mid-', 'medium distance', 'middle distance', 'mid distance'],
      gl: ['distancia media', 'distancias medias'],
      eu: ['erdiko distantzia', 'distantzia ertain', 'tarteko distantzia', 'tarteko tiro']
    },
    s_tipo_driver: {
      es: ['driver', 'drivers', 'distancia', 'lejos', 'largo', 'largos', 'salida', 'tee'],
      ca: ['lluny', 'llarg', 'llargs', 'sortida'],
      en: ['distance', ' far ', 'farther', 'further', ' long', 'longer', 'tee-off'],
      gl: ['lonxe', 'longo', 'longos', 'saida'],
      eu: ['urrun', 'urruti', 'distantzia', 'luze', 'irteera']
    },
    s_niv_principiante: {
      es: ['empez', 'empiez', 'principiante', 'novato', 'inicia', 'iniciar', 'iniciacion', 'nuevo en', 'primer disco', 'primeros discos', 'nino', 'nina', 'hijo', 'hija', 'familia'],
      ca: ['comenc', 'principiant', 'novell', 'iniciacio', 'nou en', 'nova en', 'primer disc', 'primers discos', ' nen ', ' nena ', ' fill ', ' filla ', 'infant'],
      en: ['beginner', 'begin', 'start', 'newbie', 'novice', 'just started', 'new to', 'first disc', 'first discs', ' kid', 'child', ' son ', 'daughter', 'family', 'learn'],
      gl: ['comez', 'novo en', 'nova en', 'primeiro disco', 'primeiros discos', ' neno ', ' nena ', ' fillo ', ' filla '],
      eu: ['hasiberri', 'hasteko', 'hasten ari', 'hasi berria', 'hasiera', 'lehen disko', 'lehenengo disko', 'lehen diskoak', ' ume', 'haur', ' seme', ' alaba', 'familia']
    },
    s_niv_avanzado: {
      es: ['avanzado', 'compito', 'competir', 'competicion', 'pro ', 'profesional', 'torneo'],
      ca: ['avancat', 'competeixo', 'competicio', 'professional', 'torneig', 'competint'],
      en: ['advanced', 'compete', 'competing', 'competition', 'tournament', 'professional', 'expert', 'tourney'],
      gl: ['competo', 'competicion'],
      eu: ['aurreratu', 'lehiatu', 'lehiaketa', 'txapelketa', 'profesional', 'maila altua']
    },
    s_niv_intermedio: {
      es: ['intermedio', 'ya juego', 'juego a menudo', 'nivel medio'],
      ca: ['intermedi', 'ja juguo', 'juguo sovint', 'nivell mitja'],
      en: ['intermediate', 'already play', 'play often', 'play regularly', 'been playing', 'some experience'],
      gl: ['xa xogo', 'xogo a miudo', 'nivel medio'],
      eu: ['maila ertain', 'tarteko maila', 'jada jokatzen', 'sarri jokatzen']
    },
    s_vue_viento: {
      es: ['viento', 'overstable', 'estable', 'fade', 'forehand', 'cierre', 'cierra', 'flick'],
      ca: [' vent ', ' vents ', 'sobreestable', 'tanca', 'tancament'],
      en: [' wind ', ' windy ', 'headwind', ' stable '],
      gl: [' vento', 'ventos', 'pecha', 'peche'],
      eu: ['haize', 'itxi']
    },
    s_vue_facil: {
      es: ['understable', 'se abra', 'abre', 'giro', 'turnover', 'planee', 'planeo', 'facil', 'faciles', 'hyzer flip', 'anhyzer', 'poco brazo'],
      ca: ['s obri', 'obri', ' gir', 'planegi', 'planeja', 'facils', 'poc brac', 'poca forca'],
      en: ['easy', 'easier', 'turn over', 'glides', 'gliding', 'flips', 'low arm', 'less arm', 'little arm', 'slow arm', 'weak arm', 'arm speed'],
      gl: ['xira', 'doado', 'doados', 'pouco brazo', 'pouca forza', 'planea'],
      eu: ['ezegonkor', 'erraz', 'planeatu', 'irristatu', 'beso gutxi', 'biratu']
    },
    s_vue_recto: {
      es: ['recto', 'rectos', 'neutro', 'neutros', 'straight'],
      ca: ['recte', 'rectes', 'neutre', 'neutres'],
      en: ['neutral', 'neutrals'],
      eu: ['zuzen']
    },
    blando: {
      es: ['blando', 'blandos', 'soft', 'gomoso'],
      ca: ['tou', 'tous', 'tova', 'toves'],
      en: ['squishy', 'gummy', 'rubbery'],
      gl: ['brando', 'brandos', 'branda', 'brandas'],
      eu: ['bigun', 'biguna', 'bigunak']
    },
    barato: {
      es: ['barato', 'baratos', 'economico', 'economicos', 'low cost'],
      ca: ['barat', 'economic', 'preu baix'],
      en: ['cheap', 'inexpensive', 'budget', 'affordable', 'low price'],
      gl: ['barat', 'economic'],
      eu: ['merke', 'prezio baxu', 'ekonomiko']
    },
    /* "menos de 20", "under 20", "gehienez 20" */
    precio_max: {
      es: ['menos de', 'hasta', 'maximo', 'max', 'por debajo de'],
      ca: ['menys de', 'fins a', 'maxim', 'per sota de'],
      en: ['less than', 'under', 'up to', 'below', 'maximum', 'no more than', 'within'],
      gl: ['ata', 'por baixo de'],
      eu: ['gehienez']
    },
    /* "20 euros o menos", "20 euro baino gutxiago" */
    precio_post: {
      es: ['o menos', 'como maximo'],
      ca: ['o menys', 'com a maxim'],
      en: ['or less', 'or under', 'or below', 'max', 'tops'],
      gl: ['ou menos'],
      eu: ['baino gutxiago', 'baino gutxiagoko', 'gehienez', 'arte']
    },
    saludo: {
      es: ['hola', 'buenas', 'buenos dias', 'buenas tardes', 'hey', 'ey'],
      ca: ['bon dia', 'bona tarda', 'bones tardes', 'bon vespre', 'bona nit', 'ei'],
      en: ['hi', 'hello', 'howdy', 'hiya', 'good morning', 'good afternoon', 'good evening'],
      gl: ['ola', 'bos dias', 'boas', 'boas tardes', 'boas noites', 'bo dia'],
      eu: ['kaixo', 'egun on', 'arratsalde on', 'gabon', 'aupa']
    },
    gracias: {
      es: ['gracias', 'muchas gracias', 'genial', 'perfecto', 'ok', 'vale'],
      ca: ['gracies', 'moltes gracies', 'mil gracies', 'perfecte', 'd acord', 'dacord', 'molt be', 'excel lent', 'excel.lent', 'excellent', 'fantastic'],
      en: ['thanks', 'thank you', 'thx', 'cheers', 'perfect', 'awesome', 'cool', 'okay', 'brilliant', 'amazing', 'got it'],
      gl: ['grazas', 'moitas grazas', 'mil grazas', 'xenial', 'de acordo', 'estupendo'],
      eu: ['eskerrik asko', 'mila esker', 'esker mila', 'eskerrak', 'bikain', 'primeran', 'ados', 'ederto', 'perfektua', 'oso ondo']
    },
    /* "parecido a X", "similar to X", "como el X" (el objeto va después) */
    parecido: {
      es: ['parecido', 'parecidos', 'similar', 'similares', 'como el', 'como la', 'alternativa'],
      ca: ['semblant', 'semblants', 'similars', 'com l', 'alternativa', 'alternatives'],
      en: ['alternative', 'alternatives', 'like the', 'like a', 'like an', 'something like', 'comparable', 'equivalent'],
      gl: ['semellante', 'semellantes', 'como o', 'como a']
    },
    parecido_conector: {
      es: ['a ', 'al ', 'a la '],
      ca: ['a l ', 'a la '],
      en: ['to the ', 'to '],
      gl: ['ao ', 'a o ']
    },
    /* Euskera: el objeto va antes ("Buzzz antzeko diskoak") */
    parecido_eu: {
      eu: ['antzeko', 'bezalako', 'moduko', 'ordezko', 'pareko']
    },
    pregunta: {
      es: ['que tal', 'es bueno', 'es buena', 'sirve', 'para que', 'como vuela', 'como es', 'opinion', 'opinas', 'cuentame',
        'vale la pena', 'merece', 'info', 'que es', 'diferencia', 'mejor', ' vs ', ' o el ', ' o la ', 'compar', 'recomiendas', 'nivel', 'principiante',
        'cuanto', 'precio', 'cuesta', 'vale ', 'stock', 'quedan', 'teneis', 'tienes', 'hay ', 'peso', 'pesa', 'plastico'],
      ca: ['com es', 'es bo ', 'es bona', 'serveix', 'per a que', 'com vola', 'opinio', 'opines', 'explica', 'val la pena', 'millor', 'recomanes', 'nivell', 'principiant',
        'quant', 'preu', 'costa', ' val ', 'estoc', 'queden', 'teniu', ' tens ', 'hi ha ', ' pes ', 'plastic'],
      en: ['how is', 'is it good', 'good for', 'what about', 'what is', 'what s', 'tell me about', 'worth', 'opinion', 'think of', 'how does it', 'difference', 'better',
        ' or the ', ' or a ', 'recommend', 'level', 'beginner', 'how much', 'price', 'cost', 'in stock', 'left', 'do you have', 'have you got', 'got any',
        'is there', 'are there', 'weight', 'weigh', 'plastic', 'suitable'],
      gl: ['e bo ', 'e boa', 'serve', 'como voa', 'como e ', 'contame', 'vale a pena', 'que e', 'diferenza', 'mellor', ' ou o ', ' ou a ', 'canto', 'prezo', 'custa', 'quedan', 'tedes', ' tes ', 'hai '],
      eu: ['zer moduz', 'ona da', 'ondo dago', 'zertarako', 'nola hegan', 'nolakoa', 'iritzi', 'merezi', 'zer da', 'aldea', 'diferentzia', 'hobe', ' edo ', 'alderatu', 'gomendatzen', 'maila',
        'hasiberri', 'zenbat', 'prezio', 'balio', 'geratzen', 'dituzue', 'daukazue', 'badaukazue', 'badago', 'pisu', 'plastiko']
    },
    q_precio: {
      es: ['cuanto', 'precio', 'cuesta', 'vale '],
      ca: ['quant', 'preu', 'costa', ' val '],
      en: ['how much', 'price', 'cost'],
      gl: ['canto', 'prezo', 'custa'],
      eu: ['zenbat', 'prezio', 'balio', 'kostatzen']
    },
    q_stock: {
      es: ['stock', 'quedan', 'teneis', 'tienes', 'hay '],
      ca: ['estoc', 'queden', 'teniu', ' tens ', 'hi ha '],
      en: ['in stock', 'do you have', 'have you got', 'got any', 'available', 'is there', 'are there'],
      gl: ['tedes', ' tes ', 'hai '],
      eu: ['geratzen', 'dituzue', 'daukazue', 'badaukazue', 'badago']
    },
    q_plastico: {
      es: ['plastico', 'que es', 'como es', 'que tal', 'diferencia', 'grip', 'duro', 'blando', 'dura'],
      ca: ['plastic', 'com es', 'dur', 'tou'],
      en: ['what is', 'what s', 'how is', 'difference', 'hard', 'soft', 'durable', 'tell me'],
      gl: ['que e', 'como e ', 'diferenza', 'brando'],
      eu: ['plastiko', 'zer da', 'nolakoa', 'aldea', 'diferentzia', 'gogor', 'bigun', 'iraunkor']
    },
    plastico_solo: {
      es: ['plastico'],
      ca: ['plastic'],
      eu: ['plastiko']
    },
    nivel_disco: {
      es: ['disco', 'discos', 'empezar', 'empiezo', 'principiante'],
      ca: [' disc ', 'comencar', 'comenco', 'principiant'],
      en: [' disc ', ' discs ', 'start', 'starting', 'beginner'],
      gl: ['comezar', 'comezo'],
      eu: ['disko', 'hasi', 'hasteko', 'hasiberri']
    },
    hasta: {
      es: ['hasta'],
      ca: ['fins '],
      en: ['until', ' till '],
      gl: [' ata '],
      eu: [' arte ']
    },
    /* Dudas frecuentes (RESPUESTAS): se busca como prefijo de palabra sobre " texto " */
    c_envio: {
      es: ['envio', 'enviais', 'envias', 'envian', 'correos', 'gastos', 'cuanto tarda', 'tarda', 'seguimiento', 'canarias', 'baleares', 'ceuta', 'melilla', 'domicilio'],
      ca: ['enviam', 'envieu', 'envien', 'correus', 'despeses', 'quant triga', 'triga', 'seguiment', 'balears', 'canaries', 'domicili', 'transport'],
      en: ['ship', 'deliver', 'postage', 'how long', 'tracking', 'track', 'courier', 'balearic', 'canary'],
      gl: ['enviades', 'seguimento', 'canto tarda'],
      eu: ['bidal', 'zenbat irauten', 'zenbat denbora', 'jarraipen', 'kanariak', 'balear', 'etxera', 'garraio']
    },
    c_recogida: {
      es: ['recog', 'recoger', 'hostal', 'palau', 'en mano', 'en persona', 'quedar'],
      ca: ['recoll', 'recull', 'en ma ', 'quedem', 'passar a buscar', 'anar a buscar'],
      en: ['pick up', 'pickup', 'pick-up', 'collect ', 'in person', 'meet up', 'hand delivery', 'by hand'],
      gl: ['recol', 'en man', 'en persoa'],
      eu: ['jaso', 'eskuz esku', 'pertsonalki']
    },
    c_devolucion: {
      es: ['devol', 'devuelv', 'cambio', 'cambiar', 'reembols', 'garantia', 'defect', 'roto', 'rota'],
      ca: ['retorn', 'canvi', 'canviar', 'reembor', 'trencat', 'trencada', 'malmes', 'reclam'],
      en: ['return', 'refund', 'exchange', 'swap', 'warranty', 'guarantee', 'broken', 'faulty', 'damaged', 'send back', 'give back'],
      gl: ['danad'],
      eu: ['itzul', 'aldatu', 'aldaket', 'berme', 'akats', 'hautsi', 'apurtu']
    },
    c_club: {
      es: ['club', 'puntos', 'recompensa', 'miembro', 'fidelidad', 'canjear'],
      ca: ['punts', 'membre', 'fidelitat', 'bescanv'],
      en: ['points', 'reward', 'member', 'loyalty', 'redeem'],
      gl: ['membro', 'troc', 'canxe'],
      eu: ['klub', 'puntu', 'sari', 'kide', 'leialtasun', 'trukatu', 'truke']
    },
    c_campos: {
      es: ['campo', 'campos', 'donde jugar', 'donde se juega', 'mapa', 'cerca de mi'],
      ca: ['camp ', 'camps', 'on jugar', 'on es juga', 'on puc jugar', 'a prop meu', 'prop de mi'],
      en: ['courses', 'golf course', 'where to play', 'where can i play', 'where do you play', 'map', 'near me', 'nearby', 'nearest', 'play near', 'places to play'],
      gl: ['onde xogar', 'onde se xoga', 'preto de min', 'preto de mi'],
      eu: ['zelai', 'non jokatu', 'non jolastu', 'nire inguruan', 'gertu', 'inguruan']
    },
    c_ligas: {
      es: ['liga', 'ligas', 'evento', 'eventos', 'campeonato'],
      ca: ['lliga', 'lligues', 'esdeveniment', 'campionat'],
      en: ['league', 'event', 'championship'],
      gl: ['campionato'],
      eu: ['ekitaldi', 'txapelketa']
    },
    c_vuelo: {
      es: ['numeros de vuelo', 'que significa', 'speed', 'glide', 'turn ', 'que es el fade', 'velocidad'],
      ca: ['numeros de vol', 'que vol dir', 'velocitat', 'nombres de vol'],
      en: ['flight number', 'what do the numbers', 'what does it mean', 'what does speed', 'what does glide', 'what does turn', 'what does fade', 'what is fade', 'what is the fade', 'what s fade', 'what s the fade', 'meaning'],
      gl: ['numeros de voo', 'que e o fade'],
      eu: ['hegaldiaren zenbaki', 'hegaldi zenbaki', 'zenbaki', 'zer esan nahi du', 'zer da fade', 'zer da speed', 'zer da glide', 'zer da turn', 'abiadura']
    },
    c_plastico: {
      es: ['plastico', 'plasticos', 'diferencia entre plasticos'],
      ca: ['plastic', 'diferencia entre plastics'],
      en: ['plastic'],
      gl: ['diferenza entre plasticos'],
      eu: ['plastiko', 'plastikoen arteko aldea']
    },
    c_peso: {
      es: ['peso', 'pesos', 'gramos', 'ligero', 'pesado'],
      ca: ['pes ', 'grams', 'gram ', 'lleuger', 'pesat', 'pesada'],
      en: ['weight', 'grams', 'gram ', 'heavy', 'heavier', 'lighter', 'lightweight', 'light disc', 'how heavy'],
      gl: ['lixeir', 'pesad'],
      eu: ['pisu', 'gramo', 'arin', 'astun']
    },
    c_reglas: {
      es: ['reglas', 'como se juega', 'que es el disc golf', 'como jugar'],
      ca: ['regles', 'com es juga', 'com jugar', 'normes', 'reglament'],
      en: ['rules', 'how to play', 'how do you play', 'how is it played', 'what is disc golf', 'how does disc golf work', 'how do i play'],
      gl: ['regras', 'como se xoga', 'que e o disc golf', 'como xogar', 'normas'],
      eu: ['arau', 'nola jokatzen da', 'zer da disc golf', 'nola jokatu']
    },
    c_encamino: {
      es: ['reserva', 'reservar', 'preventa', 'en camino', 'proximamente', 'agotado', 'sin stock', 'cuando llegan', 'cuando llega', 'avisame', 'avisais'],
      ca: ['en cami', 'de cami', 'properament', 'esgotat', 'sense estoc', 'sense stock', 'quan arriben', 'quan arriba', 'avisa m', 'aviseu', 'avisar'],
      en: ['reserve', 'pre-order', 'preorder', 'pre order', 'on the way', 'on its way', 'coming soon', 'sold out', 'out of stock', 'when will it be back', 'when is it back', 'when will they be back', 'when do they arrive', 'when does it arrive', 'notify', 'let me know when', 'back in stock', 'restock'],
      gl: ['esgotad', 'sen stock', 'sen existencias', 'cando chegan', 'cando chega', 'avisades'],
      eu: ['erreserba', 'aurresalmenta', 'aurre-salmenta', 'bidean', 'laster', 'agortu', 'stockik gabe', 'noiz iritsiko', 'noiz iristen', 'abisatu']
    },
    c_descuentos: {
      es: ['descuento', 'descuentos', 'oferta', 'ofertas', 'rebaja', 'rebajas', 'promo', 'promocion', 'cupon', 'codigo', 'black friday', 'saldo', 'outlet', 'dto'],
      ca: ['descompte', 'rebaixa', 'cupo', 'codi', 'saldos'],
      en: ['discount', 'offer', 'deal', 'promotion', 'coupon', 'code', 'sale ', 'sales', 'on sale', 'bargain', 'clearance', 'markdown'],
      gl: ['desconto', 'rebaixa'],
      eu: ['deskontu', 'eskaintza', 'prezio jaitsiera', 'jaitsiera', 'promozio', 'kupoi', 'kode', 'merkealdi']
    },
    c_regalo: {
      es: ['regalo', 'regalar', 'tarjeta regalo', 'cumple', 'cumpleanos', 'navidad', 'reyes', 'amigo invisible'],
      ca: ['regal', 'targeta regal', 'targeta de regal', 'aniversari', 'nadal', 'reis', 'amic invisible'],
      en: ['gift', 'birthday', 'christmas', 'xmas', 'secret santa', 'three kings'],
      gl: ['agasall', 'tarxeta agasallo', 'tarxeta regalo', 'aniversario', 'nadal', 'reis'],
      eu: ['opari', 'urtebetetze', 'gabon', 'errege', 'lagun ikusezin']
    },
    c_tienda: {
      es: ['tienda fisica', 'donde estais', 'donde esta la tienda', 'local', 'direccion', 'horario', 'abris', 'visitar'],
      ca: ['botiga fisica', 'on sou', 'on esteu', 'on es la botiga', 'on es troba', 'adreca', 'horari', 'obriu'],
      en: ['physical store', 'physical shop', 'brick and mortar', 'where are you', 'where is the shop', 'where is the store', 'address', 'opening hours', 'opening times', 'are you open', 'when are you open', 'visit', 'location', 'showroom'],
      gl: ['tenda fisica', 'onde estades', 'onde esta a tenda', 'enderezo', 'abrides'],
      eu: ['denda fisiko', 'non zaudete', 'non dago denda', 'helbide', 'ordutegi', 'zabalik', 'bisita', 'lokal']
    },
    c_pago: {
      es: ['pagar', 'pago', 'bizum', 'paypal', 'tarjeta de credito', 'transferencia'],
      ca: ['pagam', 'targeta de credit', 'formes de pagament'],
      en: ['pay', 'credit card', 'debit card', 'card payment', 'bank transfer', 'transfer'],
      gl: ['pagam', 'tarxeta de credito'],
      eu: ['ordain', 'kreditu', 'transferentzia']
    },
    c_contacto: {
      es: ['contacto', 'contactar', 'hablar con', 'persona ', 'personas ', 'email', 'telefono', 'instagram', 'whatsapp', 'escribiros'],
      ca: ['contacte', 'parlar amb', 'persones ', 'correu', 'telefon', 'escriure', 'escriu'],
      en: ['contact', 'talk to', 'speak to', 'speak with', 'get in touch', 'human', 'a person', 'real person', 'phone', 'telephone', 'call you', 'write to you', 'message you', 'reach you', 'reach out'],
      gl: ['falar con', 'persoa ', 'persoas ', 'escribirvos'],
      eu: ['harreman', 'kontaktu', 'hitz egin', 'pertsona', 'posta', 'idatz']
    }
  };
  /* ==/KW== */
  /* Une las palabras de los 5 idiomas de una lista */
  function kw(nombre) {
    return IDIOMAS.reduce(function (acc, l) { return acc.concat(KW[nombre][l] || []); }, []);
  }
  /* Une los diccionarios de sinónimos de los 5 idiomas */
  function kwObj(nombre) {
    var r = {};
    IDIOMAS.forEach(function (l) {
      var o = KW[nombre][l] || {};
      Object.keys(o).forEach(function (k) { r[k] = (r[k] || []).concat(o[k]); });
    });
    return r;
  }
  var RE_BLANDO = new RegExp('\\b(' + kw('blando').join('|') + ')\\b');
  var RE_PRECIO = new RegExp('\\b(' + kw('precio_max').join('|') + ')\\s*(\\d+)');
  var RE_PRECIO_POST = new RegExp('(\\d+)\\s*(?:€|euros?|eur)?\\s*(?:' + kw('precio_post').join('|') + ')\\b');
  var RE_SALUDO = new RegExp('^(' + kw('saludo').join('|') + ')\\b');
  var RE_GRACIAS = new RegExp('^(' + kw('gracias').join('|') + ')\\b');
  var RE_PARECIDO = new RegExp('(' + kw('parecido').join('|') + ')\\s+(' + kw('parecido_conector').join('|') + ')?(.+)$');
  /* Euskera: "X antzeko diskoak". Los dos grupos vacíos mantienen el objeto en parecido[3], como RE_PARECIDO */
  var RE_PARECIDO_EU = new RegExp('^()()(.+?)\\s+(?:' + kw('parecido_eu').join('|') + ')');

  /* ---------- Conversación que se mantiene entre páginas ---------- */
  var CLAVE_HISTORIAL = 'lf-asis-historial';
  function guardarHistorial() {
    try {
      sessionStorage.setItem(CLAVE_HISTORIAL, JSON.stringify({ t: Date.now(), h: lista.innerHTML }));
    } catch (e) {}
  }
  function recuperarHistorial() {
    try {
      var h = JSON.parse(sessionStorage.getItem(CLAVE_HISTORIAL) || 'null');
      if (!h || Date.now() - h.t > 30 * 60 * 1000 || !h.h) return false;
      lista.innerHTML = h.h;
      lista.querySelectorAll('.lf-asis__opcion').forEach(function (b) { b.disabled = true; });
      lista.querySelectorAll('.lf-asis__puntos').forEach(function (p) { var m = p.closest('.lf-asis__msg'); if (m) m.remove(); });
      return true;
    } catch (e) { return false; }
  }

  /* ---------- Mensajes ---------- */
  function bajar() { lista.scrollTop = lista.scrollHeight; }
  function pintar(html, quien) {
    var m = document.createElement('div');
    m.className = 'lf-asis__msg lf-asis__msg--' + (quien || 'bot');
    m.innerHTML = html;
    lista.appendChild(m);
    bajar();
    guardarHistorial();
    return m;
  }
  function escribiendo() { return pintar('<span class="lf-asis__puntos"><i></i><i></i><i></i></span>'); }
  /* El bot "escribe" un momento antes de contestar; los mensajes salen en orden */
  function decir(html, despues) {
    cola = cola.then(function () {
      var e = escribiendo();
      var pausa = Math.min(900, 280 + html.replace(/<[^>]+>/g, '').length * 4);
      return new Promise(function (ok) {
        setTimeout(function () { e.remove(); pintar(html); if (despues) despues(); ok(); }, pausa);
      });
    });
    return cola;
  }
  function yo(texto) { pintar(esc(texto), 'yo'); }
  function opciones(lista_opciones) {
    cola = cola.then(function () {
      var cont = document.createElement('div');
      cont.className = 'lf-asis__opciones';
      lista_opciones.forEach(function (o) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'lf-asis__opcion';
        b.textContent = o.texto;
        b.addEventListener('click', function () {
          cont.querySelectorAll('button').forEach(function (x) { x.disabled = true; });
          b.classList.add('is-elegida');
          yo(o.texto);
          o.accion();
        });
        cont.appendChild(b);
      });
      lista.appendChild(cont);
      bajar();
      guardarHistorial();
    });
  }
  function formulario() {
    cola = cola.then(function () {
      var t = document.getElementById('lf-asis-contacto');
      var cont = document.createElement('div');
      cont.className = 'lf-asis__msg lf-asis__msg--bot';
      cont.appendChild(t.content.cloneNode(true));
      lista.appendChild(cont);
      bajar();
    });
  }

  /* ---------- Catálogo ---------- */
  function cargarCatalogo() {
    if (catalogo) return Promise.resolve(catalogo);
    try {
      var cache = JSON.parse(sessionStorage.getItem('lf-asis-catalogo') || 'null');
      if (cache && Date.now() - cache.t < 20 * 60 * 1000) { catalogo = cache.d; return Promise.resolve(catalogo); }
    } catch (e) {}
    var base = url('/collections/all') + '?view=lf-datos&page=';
    return fetch(base + 1).then(function (r) { return r.json(); }).then(function (p1) {
      var pedidas = [];
      for (var i = 2; i <= p1.paginas; i++) pedidas.push(fetch(base + i).then(function (r) { return r.json(); }));
      return Promise.all(pedidas).then(function (resto) {
        var productos = resto.reduce(function (acc, p) { return acc.concat(p.productos); }, p1.productos);
        productos.forEach(function (p) {
          p.busca = {
            t: normal(p.t),
            tipo: normal(p.tipo + ' ' + p.tg + ' ' + p.m),
            pl: normal(p.pl),
            x: normal(p.x)
          };
        });
        catalogo = { productos: productos, colecciones: p1.colecciones || [], guias: p1.guias || [], plasticos: p1.plasticos || [], campana: p1.campana || null };
        try { sessionStorage.setItem('lf-asis-catalogo', JSON.stringify({ t: Date.now(), d: catalogo })); } catch (e) {}
        return catalogo;
      });
    });
  }
  function tipoDe(d) {
    var t = normal(d.tipo);
    if (t.indexOf('putt') !== -1 || t.indexOf('approach') !== -1) return 'putter';
    if (t.indexOf('mid') !== -1) return 'mid';
    if (t.indexOf('fairway') !== -1) return 'fairway';
    if (t.indexOf('distan') !== -1) return 'distance';
    if (!d.s) return '';
    return d.s <= 4 ? 'putter' : d.s <= 6 ? 'mid' : d.s <= 9 ? 'fairway' : 'distance';
  }
  var TIPOS = {
    putter: { nombre: tx('tipo_putter'), coleccion: '/collections/putters-approach' },
    mid: { nombre: tx('tipo_mid'), coleccion: '/collections/midrange' },
    fairway: { nombre: tx('tipo_fairway'), coleccion: '/collections/fairway-drivers' },
    distance: { nombre: tx('tipo_distance'), coleccion: '/collections/distance-drivers' }
  };
  function numeros(d) { return [d.s, d.g, d.tu, d.f].map(function (n) { return String(+n).replace('.', tx('dec')); }).join(' | '); }
  function tarjeta(d) {
    var img = d.img ? '<img src="' + esc(d.img) + '" alt="" loading="lazy" width="64" height="64">' : '<span class="lf-asis__sin-foto"></span>';
    return '<a class="lf-asis__disco" href="' + esc(d.url) + '">' + img +
      '<span><strong>' + esc(d.titulo) + '</strong>' +
      (d.detalle ? '<small>' + esc(d.detalle) + '</small>' : '') +
      (d.precio ? '<em>' + esc(d.precio) + '</em>' : '') + '</span></a>';
  }
  function ficha(d) {
    var detalle = d.m;
    if (d.s) detalle += ' · ' + numeros(d);
    if (!d.d) detalle += ' · ' + tx('agotado');
    return tarjeta({ url: d.u, img: d.i, titulo: d.t, detalle: detalle, precio: d.p });
  }
  function bloque(productos) { return '<div class="lf-asis__discos">' + productos.map(ficha).join('') + '</div>'; }
  function molde(d) { return normal(d.t).split(' ')[0]; }
  function sinRepetir(lista_p, cuantos) {
    var vistos = {};
    return lista_p.filter(function (d) {
      var m = molde(d);
      if (vistos[m]) return false;
      vistos[m] = true;
      return true;
    }).slice(0, cuantos);
  }

  /* ---------- Entender lo que escriben ---------- */
  var VACIAS = kw('vacias');
  var SINONIMOS = kwObj('sinonimos');
  var SENALES = {
    tipo: [
      ['fairway', kw('s_tipo_fairway')],
      ['putter', kw('s_tipo_putter')],
      ['mid', kw('s_tipo_mid')],
      ['driver', kw('s_tipo_driver')]
    ],
    nivel: [
      ['principiante', kw('s_niv_principiante')],
      ['avanzado', kw('s_niv_avanzado')],
      ['intermedio', kw('s_niv_intermedio')]
    ],
    vuelo: [
      ['viento', kw('s_vue_viento')],
      ['facil', kw('s_vue_facil')],
      ['recto', kw('s_vue_recto')]
    ]
  };
  function leerSenales(n) {
    var r = {};
    var con_espacios = ' ' + n + ' ';
    Object.keys(SENALES).forEach(function (clave) {
      SENALES[clave].some(function (par) {
        if (contiene(con_espacios, par[1])) { r[clave] = par[0]; return true; }
        return false;
      });
    });
    if (RE_BLANDO.test(n)) r.blando = true;
    var precio = n.match(RE_PRECIO);
    if (precio) r.precioMax = +precio[2] * 100;
    else {
      var despues = n.match(RE_PRECIO_POST);
      if (despues) r.precioMax = +despues[1] * 100;
    }
    if (contiene(n, kw('barato'))) r.barato = true;
    return r;
  }
  function marcaEn(n) {
    if (!catalogo) return '';
    var marcas = {};
    catalogo.productos.forEach(function (p) { marcas[normal(p.m)] = p.m; });
    var encontrada = '';
    Object.keys(marcas).forEach(function (m) {
      var corta = m.split(' ')[0];
      if (corta.length > 2 && (n.indexOf(m) !== -1 || (' ' + n + ' ').indexOf(' ' + corta + ' ') !== -1)) encontrada = marcas[m];
    });
    return encontrada;
  }
  function palabras(n) {
    return n.split(' ').filter(function (w) { return w.length > 1 && VACIAS.indexOf(w) === -1; });
  }

  /* ---------- Búsqueda libre en el catálogo ---------- */
  function puntuarTexto(p, ws) {
    var total = 0, encontradas = 0;
    ws.forEach(function (w) {
      var variantes = [{ w: raizPalabra(w), peso: 1 }].concat((SINONIMOS[w] || SINONIMOS[raizPalabra(w)] || []).map(function (s) { return { w: s, peso: 0.8 }; }));
      var mejor = 0;
      variantes.forEach(function (v) {
        var x = v.w;
        if ((' ' + p.busca.t).indexOf(' ' + x) !== -1) mejor = Math.max(mejor, 6 * v.peso);
        else if (p.busca.t.indexOf(x) !== -1) mejor = Math.max(mejor, 4 * v.peso);
        if (p.busca.tipo.indexOf(x) !== -1) mejor = Math.max(mejor, 4 * v.peso);
        if (p.busca.pl && p.busca.pl.indexOf(x) !== -1) mejor = Math.max(mejor, 3 * v.peso);
        if (x.length > 3 && p.busca.x.indexOf(x) !== -1) mejor = Math.max(mejor, 1.5 * v.peso);
      });
      if (mejor > 0) encontradas++;
      total += mejor;
    });
    if (!ws.length || encontradas < Math.ceil(ws.length / 2)) return 0;
    if (p.d) total += 1;
    if (p.s) total += 0.5;
    return total;
  }
  function buscarEnCatalogo(ws) {
    return catalogo.productos
      .map(function (p) { return { p: p, s: puntuarTexto(p, ws) }; })
      .filter(function (x) { return x.s > 0; })
      .sort(function (a, b) { return b.s - a.s; })
      .map(function (x) { return x.p; });
  }
  var GENERICAS = kw('genericas');
  function buscarEnLista(items, ws) {
    return items.filter(function (it) {
      var t = normal(it.t);
      return ws.some(function (w) { return w.length > 3 && GENERICAS.indexOf(w) === -1 && t.indexOf(raizPalabra(w)) !== -1; });
    });
  }

  /* ---------- Recomendaciones de discos ---------- */
  function puntuarDisco(d, pf) {
    var tipo = tipoDe(d), s = d.s, g = d.g, tu = d.tu, f = d.f, est = tu + f, p = 0;
    var nivel = pf.nivel, niveles = ' ' + d.n + ' ';
    if (nivel && niveles.indexOf(' ' + nivel + ' ') !== -1) p += 3;
    if (niveles.indexOf(' todos-los-niveles ') !== -1) p += 2;
    if (nivel === 'principiante') {
      if (niveles.indexOf(' avanzado ') !== -1 && niveles.indexOf(' principiante ') === -1) p -= 3;
      if (s > 9) return -99;
      if (f <= 2) p += 1;
      if (g >= 4) p += 1;
      if ((tipo === 'fairway' || tipo === 'mid') && tu <= -1) p += 1.5;
      if (f >= 3) p -= 2;
    }
    if (nivel === 'intermedio' && s > 12) p -= 2;
    if (pf.vuelo === 'recto') p += (est >= -1 && est <= 1.5) ? 3 : -1;
    if (pf.vuelo === 'facil') p += est < 0 ? 3 : (est <= 1 ? 1 : -2);
    if (pf.vuelo === 'viento') p += est >= 2.5 ? 3 : (est >= 1.5 ? 1 : -2);
    if (pf.blando && /soft|g7|rubber|blend|classic|zero|exo soft/.test(normal(d.t + ' ' + d.pl))) p += 2;
    if (pf.barato) p -= d.pr / 1000;
    if (d.c && Date.now() / 1000 - d.c < 60 * 86400) p += 0.5;
    return p;
  }
  function mejores(tipos, pf, cuantos) {
    var lista_p = catalogo.productos.filter(function (d) {
      if (!d.d || tipos.indexOf(tipoDe(d)) === -1) return false;
      if (pf.marca && d.m !== pf.marca) return false;
      if (pf.precioMax && d.pr > pf.precioMax) return false;
      return true;
    });
    return sinRepetir(lista_p
      .map(function (d) { return { d: d, p: puntuarDisco(d, pf) }; })
      .filter(function (x) { return x.p > -50; })
      .sort(function (a, b) { return b.p - a.p; })
      .map(function (x) { return x.d; }), cuantos);
  }
  function parecidos(base, cuantos) {
    var tipo = tipoDe(base);
    return sinRepetir(catalogo.productos
      .filter(function (d) { return d.d && d.s && tipoDe(d) === tipo && molde(d) !== molde(base); })
      .map(function (d) {
        var dist = Math.abs(d.s - base.s) * 1.2 + Math.abs(d.g - base.g) * 0.5 + Math.abs(d.tu - base.tu) + Math.abs(d.f - base.f);
        return { d: d, dist: dist };
      })
      .sort(function (a, b) { return a.dist - b.dist; })
      .map(function (x) { return x.d; }), cuantos);
  }
  var NOMBRE_VUELO = { recto: tx('vuelo_recto'), facil: tx('vuelo_facil'), viento: tx('vuelo_viento') };
  var NOMBRE_NIVEL = { principiante: tx('nivel_principiante'), intermedio: tx('nivel_intermedio'), avanzado: tx('nivel_avanzado') };

  function recomendar(pf) {
    return cargarCatalogo().then(function () {
      var tipos, enlace, html = '';
      if (pf.tipo === 'set') {
        var set = [].concat(mejores(['putter'], pf, 1), mejores(['mid'], pf, 1), mejores(['fairway'], pf, 1));
        html = tx('rec_set') + bloque(set);
        var packs = catalogo.productos.filter(function (d) { return d.d && /pack/.test(normal(d.tipo)); });
        if (packs.length) html += tx('rec_packs') + bloque(packs.slice(0, 2));
        html += '<a class="lf-asis__mas" href="' + url('/blogs/guias/como-elegir-tu-primer-disco-de-disc-golf') + '">' + tx('rec_mas_primer') + '</a>';
        decir(html);
        alFinal();
        return;
      }
      if (pf.tipo === 'driver') {
        tipos = pf.nivel === 'principiante' ? ['fairway'] : ['fairway', 'distance'];
        enlace = pf.nivel === 'principiante' ? TIPOS.fairway : TIPOS.distance;
      } else {
        tipos = [pf.tipo];
        enlace = TIPOS[pf.tipo];
      }
      var elegidos = mejores(tipos, pf, 4);
      if (!elegidos.length) {
        decir(tx('rec_vacio', { marca: pf.marca ? tx('de_marca_vacio', { m: esc(pf.marca) }) : '', u: url(enlace.coleccion), n: enlace.nombre }));
        formulario();
        return;
      }
      if (pf.tipo === 'driver' && pf.nivel === 'principiante') {
        html += tx('rec_fairway_principiante');
      }
      var piezas = {
        tipo: pf.tipo === 'driver' ? tx('tipo_driver') : enlace.nombre,
        vuelo: pf.vuelo ? NOMBRE_VUELO[pf.vuelo] : '',
        nivel: pf.nivel ? NOMBRE_NIVEL[pf.nivel] : '',
        marca: pf.marca ? tx('de_marca', { m: esc(pf.marca) }) : ''
      };
      var desc = tx('desc_orden').map(function (k) { return piezas[k]; }).filter(Boolean).join(' ');
      html += una(tx('rec_intro', { d: desc })) + bloque(elegidos);
      html += '<a class="lf-asis__mas" href="' + url(enlace.coleccion) + '">' + tx('rec_ver_todos', { n: enlace.nombre }) + '</a>';
      decir(html);
      alFinal();
    }).catch(errorCatalogo);
  }
  /* ---------- Preguntas sobre un disco o un plástico concreto ---------- */
  var PREGUNTA = kw('pregunta');
  function moldesEn(n) {
    var tokens = (' ' + n.replace(/[?¿!¡,.]/g, ' ') + ' ').replace(/\s+/g, ' ');
    var vistos = {}, encontrados = [];
    catalogo.productos.forEach(function (p) {
      if (!p.s) return;
      var m = molde(p);
      if (m.length < 2 || GENERICAS.indexOf(m) !== -1 || VACIAS.indexOf(m) !== -1 || vistos[m]) return;
      var pos = tokens.indexOf(' ' + m + ' ');
      if (pos === -1) return;
      vistos[m] = true;
      encontrados.push({ m: m, pos: pos });
    });
    return encontrados.sort(function (a, b) { return a.pos - b.pos; }).map(function (x) { return x.m; });
  }
  function versionesDe(m) {
    var lista_p = catalogo.productos.filter(function (p) { return molde(p) === m; });
    return lista_p.filter(function (p) { return p.d; }).concat(lista_p.filter(function (p) { return !p.d; }));
  }
  function frase(t) { return (t || '').replace(/\s+/g, ' ').replace(/\s*—\s*/g, ': ').trim(); }
  function resumen(t, frases) {
    var partes = frase(t).replace(/\.\.\.$/, '').replace(/([.!?])\s+(?=[\p{Lu}¿¡"«])/gu, '$1\u0001').split('\u0001');
    var r = partes.slice(0, frases).join(' ').trim();
    return /[.!?]$/.test(r) ? r : r + '…';
  }
  function infoDisco(m, n) {
    n = n || '';
    var versiones = versionesDe(m);
    var d = versiones.filter(function (p) { return p.db && !/ pro /.test(' ' + normal(p.t) + ' '); })[0] ||
      versiones.filter(function (p) { return p.db; })[0] || versiones[0];
    var nivel = d.n.indexOf('principiante') !== -1 ? tx('nv_princ') :
      d.n.indexOf('todos-los-niveles') !== -1 ? tx('nv_todos') :
      d.n.indexOf('avanzado') !== -1 ? tx('nv_avanz') : '';
    var nombre = d.t.split(' ')[0];
    var disponibles = versiones.filter(function (p) { return p.d; });
    var html = '';
    var simple = false;
    if (contiene(n, kw('q_precio'))) {
      var precios = (disponibles.length ? disponibles : versiones).map(function (p) { return p.pr; });
      var min = Math.min.apply(null, precios) / 100;
      html = tx('info_precio', { n: esc(nombre), p: dinero(min), fin: versiones.length > 1 ? tx('segun_plastico') : '.' });
    } else if (contiene(n, kw('q_stock'))) {
      html = disponibles.length ? tx('info_si', { n: esc(nombre) }) : tx('info_agotado', { n: esc(nombre) });
    } else {
      simple = true;
    }
    html += (simple ? tx('info_vuela_n', { n: esc(nombre) }) : tx('info_vuela')) + numeros(d) + '. ' + nivel;
    if (d.db) html += '<br><br>' + esc(resumen(d.db, 2));
    decir(html);
    decir(disponibles.length ? (disponibles.length > 1 ? tx('versiones', { k: disponibles.length }) : tx('lo_tengo')) + bloque(disponibles.slice(0, 4)) :
      tx('agotado_aviso') + bloque(versiones.slice(0, 1)));
    var ops = [];
    if (d.cmp) ops.push({ texto: tx('op_compara'), accion: function () { decir(esc(resumen(d.cmp, 4))); alFinal(); } });
    ops.push(
      { texto: tx('op_parecidos'), accion: function () { decir(tx('parecido_a', { n: esc(nombre) }) + bloque(parecidos(d, 4))); alFinal(); } },
      { texto: tx('op_otra'), accion: function () { decir(una(tx('otra_a'))); entrada.focus(); } }
    );
    opciones(ops);
  }
  function compararDiscos(m1, m2) {
    var a = versionesDe(m1)[0], b = versionesDe(m2)[0];
    var na = a.t.split(' ')[0], nb = b.t.split(' ')[0];
    var ea = a.tu + a.f, eb = b.tu + b.f, partes = [];
    if (Math.abs(a.s - b.s) >= 1) {
      var r = a.s > b.s ? [na, nb, a.s, b.s] : [nb, na, b.s, a.s];
      partes.push(tx('cmp_rapido', { a: esc(r[0]), x: r[2], y: r[3] }));
    }
    if (Math.abs(ea - eb) >= 1) {
      var e = ea > eb ? [na, nb] : [nb, na];
      partes.push(tx('cmp_estable', { a: esc(e[0]), b: esc(e[1]) }));
    }
    if (Math.abs(a.g - b.g) >= 1) {
      var g = a.g > b.g ? na : nb;
      partes.push(tx('cmp_planea', { a: esc(g) }));
    }
    if (!partes.length) partes.push(tx('cmp_igual'));
    decir(tx('cmp_cab', { a: esc(na), x: numeros(a), b: esc(nb), y: numeros(b) }) + partes.join(' ') + bloque([a, b]));
    alFinal();
  }
  var NO_FAMILIA = ['putter', 'classic', 'special', 'rubber', 'color', 'gold', 'royal', 'project', 'grand', 'zero', 'active', 'tournament',
    'titanium', 'prism', 'particle', 'eclipse', 'horizon', 'big', 'exo', 'opto ice'];
  function nombrePlastico(pl) { return normal(pl.n.replace(/\(.*\)/, '')).replace(/-/g, ' ').trim(); }
  function plasticoEn(n) {
    var limpio = ' ' + n.replace(/-/g, ' ') + ' ';
    var mejor = null;
    (catalogo.plasticos || []).forEach(function (pl) {
      var nombre = nombrePlastico(pl);
      if (nombre.length < 2) return;
      if (limpio.indexOf(' ' + nombre + ' ') !== -1 && (!mejor || nombre.length > nombrePlastico(mejor).length)) mejor = pl;
    });
    if (mejor) return mejor;
    /* "K1", "Opto", "Neutron"...: familia de plásticos */
    (catalogo.plasticos || []).forEach(function (pl) {
      var primera = nombrePlastico(pl).split(' ')[0];
      if (!mejor && primera.length >= 2 && NO_FAMILIA.indexOf(primera) === -1 && limpio.indexOf(' ' + primera + ' ') !== -1) mejor = pl;
    });
    return mejor;
  }
  function infoPlastico(pl) {
    var familia = nombrePlastico(pl).split(' ')[0];
    var hermanos = (catalogo.plasticos || []).filter(function (x) { return nombrePlastico(x).split(' ')[0] === familia && x.m === pl.m; });
    var discos_pl = catalogo.productos.filter(function (p) { return p.d && p.pl && normal(p.pl).replace(/-/g, ' ').split(' ')[0] === familia; });
    var html = (pl.m ? tx('pl_con_marca', { n: esc(pl.n), m: esc(pl.m) }) : tx('pl_sin_marca', { n: esc(pl.n) })) + esc(frase(pl.x));
    if (hermanos.length > 1) html += tx('pl_familia', { l: hermanos.map(function (x) { return esc(x.n); }).join(', ') });
    decir(html);
    if (discos_pl.length) decir(tx('pl_discos', { n: esc(familia.toUpperCase() === familia ? familia : pl.n.split(' ')[0]) }) + bloque(sinRepetir(discos_pl, 4)));
    alFinal();
  }

  function errorCatalogo() {
    decir(tx('err_catalogo', { u: url('/collections/all') }));
  }

  /* ---------- Preguntas guiadas ---------- */
  function buscador(pf) {
    perfil = pf || {};
    if (!perfil.nivel) {
      decir(una(tx('q_nivel')));
      opciones([
        { texto: tx('op_empezando'), accion: function () { perfil.nivel = 'principiante'; buscador(perfil); } },
        { texto: tx('op_menudo'), accion: function () { perfil.nivel = 'intermedio'; buscador(perfil); } },
        { texto: tx('op_compito'), accion: function () { perfil.nivel = 'avanzado'; buscador(perfil); } }
      ]);
      return;
    }
    if (!perfil.tipo) {
      decir(una(tx('q_tipo')));
      var ops = [];
      if (perfil.nivel === 'principiante') ops.push({ texto: tx('op_set'), accion: function () { perfil.tipo = 'set'; recomendar(perfil); } });
      ops.push(
        { texto: tx('op_putter'), accion: function () { perfil.tipo = 'putter'; buscador(perfil); } },
        { texto: tx('op_mid'), accion: function () { perfil.tipo = 'mid'; buscador(perfil); } },
        { texto: tx('op_driver'), accion: function () { perfil.tipo = 'driver'; buscador(perfil); } }
      );
      opciones(ops);
      return;
    }
    if (perfil.vuelo === undefined && perfil.tipo !== 'set') {
      if (perfil.nivel === 'principiante') { perfil.vuelo = perfil.tipo === 'putter' ? 'recto' : 'facil'; recomendar(perfil); return; }
      decir(una(tx('q_vuelo')));
      opciones([
        { texto: tx('op_recto'), accion: function () { perfil.vuelo = 'recto'; recomendar(perfil); } },
        { texto: tx('op_facil'), accion: function () { perfil.vuelo = 'facil'; recomendar(perfil); } },
        { texto: tx('op_viento'), accion: function () { perfil.vuelo = 'viento'; recomendar(perfil); } },
        { texto: tx('op_igual'), accion: function () { perfil.vuelo = ''; recomendar(perfil); } }
      ]);
      return;
    }
    recomendar(perfil);
  }

  /* ---------- Respuestas a dudas frecuentes ---------- */
  var RESPUESTAS = {
    envio: {
      claves: kw('c_envio'),
      html: function () { return tx('r_envio', { u: url('/policies/shipping-policy') }); }
    },
    recogida: {
      claves: kw('c_recogida'),
      html: function () { return tx('r_recogida', { u: url('/policies/shipping-policy') }); }
    },
    devolucion: {
      claves: kw('c_devolucion'),
      html: function () { return tx('r_devolucion', { u: url('/policies/refund-policy') }); }
    },
    club: {
      claves: kw('c_club'),
      html: function () { return tx('r_club', { u: url('/pages/club') }); }
    },
    campos: {
      claves: kw('c_campos'),
      html: function () { return tx('r_campos', { u: url('/pages/campos-de-disc-golf') }); }
    },
    ligas: {
      claves: kw('c_ligas'),
      html: function () { return tx('r_ligas', { u: url('/pages/ligas') }); }
    },
    vuelo: {
      claves: kw('c_vuelo'),
      html: function () { return tx('r_vuelo', { u: url('/blogs/guias/numeros-de-vuelo-disc-golf') }); }
    },
    plastico: {
      claves: kw('c_plastico'),
      html: function () { return tx('r_plastico', { u: url('/blogs/guias/plasticos-de-disc-golf') }); }
    },
    peso: {
      claves: kw('c_peso'),
      html: function () { return tx('r_peso'); }
    },
    reglas: {
      claves: kw('c_reglas'),
      html: function () { return tx('r_reglas', { u1: url('/blogs/guias/reglas-basicas-disc-golf'), u2: url('/pages/que-es-el-disc-golf') }); }
    },
    encamino: {
      claves: kw('c_encamino'),
      html: function () { return tx('r_encamino', { u: url('/collections/proximamente-disponibles') }); }
    },
    descuentos: {
      claves: kw('c_descuentos'),
      html: function () {
        var partes = [];
        var c = catalogo && catalogo.campana;
        if (c) partes.push('🔥 <strong>' + esc(c.t) + '</strong>: ' + esc(c.x || '') + (c.fin && !contiene(' ' + normal(c.x || '') + ' ', kw('hasta')) ? tx('camp_fin', { f: esc(c.fin) }) : '') + (c.u ? tx('camp_ver', { u: esc(c.u) }) : ''));
        partes.push(tx('r_descuentos_club', { u: url('/pages/club') }));
        return partes.join('<br><br>');
      },
      despues: function () {
        if (!catalogo) return;
        var rebajados = catalogo.productos.filter(function (p) { return p.d && p.cp > p.pr; })
          .sort(function (a, b) { return (b.cp - b.pr) / b.cp - (a.cp - a.pr) / a.cp; });
        if (rebajados.length) decir(tx('d_rebajados') + bloque(rebajados.slice(0, 4)));
        else {
          var xout = catalogo.productos.filter(function (p) { return p.d && /x out|x-out|lab second|l2/.test(normal(p.t)); });
          if (xout.length) decir(tx('d_xout') + bloque(sinRepetir(xout, 4)));
        }
      }
    },
    regalo: {
      claves: kw('c_regalo'),
      html: function () { return tx('r_regalo', { u: url('/products/tarjeta-regalo-la-flama') }); },
      despues: function () {
        if (!catalogo) return;
        var cajas = catalogo.productos.filter(function (p) { return p.d && /mystery|pack/.test(normal(p.tipo)); });
        if (cajas.length) decir(tx('d_cajas') + bloque(cajas.slice(0, 4)));
      }
    },
    tienda: {
      claves: kw('c_tienda'),
      html: function () { return tx('r_tienda'); }
    },
    pago: {
      claves: kw('c_pago'),
      html: function () { return tx('r_pago'); }
    },
    contacto: {
      claves: kw('c_contacto'),
      html: function () { return tx('r_contacto'); },
      formulario: true
    }
  };
  function dudaFrecuente(n) {
    var mejor = null, puntos = 0;
    Object.keys(RESPUESTAS).forEach(function (k) {
      var p = 0;
      RESPUESTAS[k].claves.forEach(function (c) { if ((' ' + n + ' ').indexOf(' ' + c) !== -1) p += c.length; });
      if (p > puntos) { puntos = p; mejor = k; }
    });
    return mejor;
  }
  function responder(clave) {
    var r = RESPUESTAS[clave];
    var mostrar = function () {
      decir(r.html());
      if (r.despues) r.despues();
      if (r.formulario) formulario();
      else alFinal();
    };
    if (r.despues || clave === 'descuentos') cargarCatalogo().then(mostrar, mostrar); else mostrar();
  }

  /* ---------- Qué hacer con un mensaje escrito ---------- */
  function procesar(texto) {
    var n = normal(texto);
    if (RE_SALUDO.test(n) && n.split(' ').length <= 3) {
      decir(tx('p_saludo'));
      menu();
      return;
    }
    if (RE_GRACIAS.test(n) && n.split(' ').length <= 3) {
      decir(tx('p_gracias'));
      return;
    }
    var duda = dudaFrecuente(n);
    cargarCatalogo().then(function () {
      var senales = leerSenales(n);
      var marca = marcaEn(n);
      var ws = palabras(n);

      /* "parecido a X" o "como el X" */
      var parecido = n.match(RE_PARECIDO) || n.match(RE_PARECIDO_EU);
      if (parecido) {
        var base = buscarEnCatalogo(palabras(parecido[3])).filter(function (p) { return p.s; })[0];
        if (base) {
          var sim = parecidos(base, 4);
          if (sim.length) { decir(tx('par_con', { n: esc(base.t), s: numeros(base) }) + bloque(sim)); alFinal(); return; }
        }
        decir(tx('par_no'));
        buscador({});
        return;
      }

      /* Comparar dos discos o preguntar por uno concreto */
      var moldes = moldesEn(n);
      if (moldes.length >= 2) { compararDiscos(moldes[0], moldes[1]); return; }
      if (moldes.length === 1 && (contiene(' ' + n + ' ', PREGUNTA) || ws.length <= 2)) { infoDisco(moldes[0], ' ' + n + ' '); return; }

      /* Preguntar por un plástico */
      var plastico = plasticoEn(n);
      if (plastico && (!senales.tipo || contiene(n, kw('plastico_solo'))) && (contiene(n, kw('q_plastico')) || ws.length <= 2)) { infoPlastico(plastico); return; }

      /* Duda frecuente sin pinta de buscar un producto */
      var servicio = ['envio', 'recogida', 'devolucion', 'pago', 'contacto', 'club', 'campos', 'ligas', 'encamino', 'descuentos', 'tienda'];
      if (duda && (!senales.tipo || servicio.indexOf(duda) !== -1)) { responder(duda); return; }

      /* Busca un tipo de disco: recomendaciones directas */
      if (senales.tipo || (senales.nivel && contiene(' ' + n + ' ', kw('nivel_disco')))) {
        var pf = { tipo: senales.tipo, nivel: senales.nivel, vuelo: senales.vuelo, marca: marca, precioMax: senales.precioMax, barato: senales.barato, blando: senales.blando };
        if (pf.tipo && (pf.vuelo || pf.nivel || pf.marca || pf.barato || pf.precioMax || pf.blando)) { recomendar(pf); return; }
        if (pf.tipo && !pf.nivel) pf.vuelo = pf.vuelo || '';
        buscador(pf);
        return;
      }

      /* Búsqueda libre en todo el catálogo */
      var encontrados = buscarEnCatalogo(ws);
      if (marca && !encontrados.length) encontrados = catalogo.productos.filter(function (p) { return p.m === marca; });
      var cols = buscarEnLista(catalogo.colecciones, ws).slice(0, 2);
      var guias = buscarEnLista(catalogo.guias, ws).slice(0, 2);
      if (encontrados.length || cols.length || guias.length) {
        var html = '';
        if (encontrados.length) {
          var disponibles = encontrados.filter(function (p) { return p.d; });
          var mostrar = (disponibles.length ? disponibles : encontrados).slice(0, 4);
          html += (encontrados.length === 1 ? una(tx('enc_uno')) : una(tx('enc_varios'))) + bloque(mostrar);
          if (!disponibles.length) html += tx('enc_agotado');
        }
        if (cols.length || guias.length) {
          html += '<div class="lf-asis__enlaces">' + cols.concat(guias).map(function (o) {
            return '<a href="' + esc(o.u) + '">' + esc(o.t) + ' →</a>';
          }).join('') + '</div>';
        }
        if (encontrados.length > 4) html += '<a class="lf-asis__mas" href="' + url('/search') + '?q=' + encodeURIComponent(texto) + '">' + tx('ver_resultados', { k: encontrados.length }) + '</a>';
        decir(html);
        opciones([
          { texto: tx('op_no_busco'), accion: function () { decir(tx('pide_correo')); formulario(); } },
          { texto: tx('op_que_disco'), accion: function () { buscador({}); } }
        ]);
        return;
      }
      if (duda) { responder(duda); return; }
      buscarEnShopify(texto);
    }).catch(function () {
      if (duda) responder(duda); else buscarEnShopify(texto);
    });
  }

  /* Último recurso: la búsqueda predictiva de Shopify */
  function buscarEnShopify(texto) {
    var q = encodeURIComponent(texto);
    fetch(url('/search/suggest.json') + '?q=' + q + '&resources[type]=product,collection,article,page&resources[limit]=4&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag,body')
      .then(function (r) { return r.json(); })
      .then(function (datos) {
        var res = (datos.resources && datos.resources.results) || {};
        var prods = res.products || [];
        var otros = [].concat(res.collections || [], res.articles || [], res.pages || []);
        if (!prods.length && !otros.length) {
          decir(una(tx('s_nada_a')) + tx('s_nada_b'));
          opciones([
            { texto: tx('op_buscar_parecido'), accion: function () { buscador({}); } },
            { texto: tx('op_pedir'), accion: function () { decir(tx('s_pide_correo')); formulario(); } }
          ]);
          return;
        }
        var html = tx('s_encontrado');
        if (prods.length) {
          html += '<div class="lf-asis__discos">' + prods.map(function (p) {
            var precio = parseFloat(p.price);
            return tarjeta({ url: p.url, img: p.image || (p.featured_image && p.featured_image.url), titulo: p.title, detalle: p.vendor + (p.available === false ? ' · ' + tx('agotado') : ''), precio: isNaN(precio) ? '' : dinero(precio) });
          }).join('') + '</div>';
        }
        if (otros.length) html += '<div class="lf-asis__enlaces">' + otros.slice(0, 3).map(function (o) { return '<a href="' + esc(o.url) + '">' + esc(o.title) + ' →</a>'; }).join('') + '</div>';
        decir(html);
        alFinal();
      })
      .catch(function () {
        decir(tx('s_error'));
      });
  }

  /* ---------- Menús ---------- */
  function menu() {
    opciones([
      { texto: tx('op_que_disco'), accion: function () { buscador({}); } },
      { texto: tx('m_packs'), accion: function () { procesar('pack caja sorpresa'); } },
      { texto: tx('m_ofertas'), accion: function () { responder('descuentos'); } },
      { texto: tx('m_envios'), accion: function () { responder('envio'); } },
      { texto: tx('m_cambios'), accion: function () { responder('devolucion'); } },
      { texto: tx('m_club'), accion: function () { responder('club'); } },
      { texto: tx('m_hablar'), accion: function () { responder('contacto'); } }
    ]);
  }
  function alFinal() {
    opciones([
      { texto: tx('op_buscar_otro'), accion: function () { buscador({}); } },
      { texto: tx('op_otra'), accion: function () { decir(una(tx('otra_b'))); entrada.focus(); } }
    ]);
  }
  function opcionesFicha() {
    if (!productoActual) return false;
    var base = null;
    return cargarCatalogo().then(function () {
      base = catalogo.productos.filter(function (p) { return p.u.split('/').pop().split('?')[0] === productoActual; })[0];
      if (!base || !base.s) return false;
      var nivel = base.n.indexOf('principiante') !== -1 ? tx('nv_princ') :
        base.n.indexOf('todos-los-niveles') !== -1 ? tx('nv_todos') :
        base.n.indexOf('avanzado') !== -1 ? tx('nv_avanz2') : '';
      decir(tx('f_viendo', { n: esc(base.t), s: numeros(base), nv: nivel }));
      opciones([
        { texto: tx('op_parecidos'), accion: function () { decir(tx('f_parecido') + bloque(parecidos(base, 4))); alFinal(); } },
        { texto: tx('op_que_disco'), accion: function () { buscador({}); } },
        { texto: tx('m_envios'), accion: function () { responder('envio'); } }
      ]);
      return true;
    }).catch(function () { return false; });
  }
  function saludo() {
    if (iniciado) return;
    iniciado = true;
    var habia = lista.children.length > 0;
    if (habia) {
      decir(una(tx('h_de_nuevo')));
      var ficha_p = opcionesFicha();
      if (ficha_p) ficha_p.then(function (ok) { if (!ok) menu(); }); else menu();
      return;
    }
    decir(una(tx('h_inicio')) + tx('h_inicio_b'));
    var fp = opcionesFicha();
    if (fp) fp.then(function (ok) { if (!ok) menu(); }); else menu();
  }

  /* ---------- Abrir y cerrar ---------- */
  function abrir(empezarBuscador) {
    panel.hidden = false;
    raiz.classList.add('is-abierto');
    lanzador.setAttribute('aria-expanded', 'true');
    aviso.hidden = true;
    guardar('lf-asis-visto', '1');
    cargarCatalogo().catch(function () {});
    if (empezarBuscador) {
      if (!iniciado) { iniciado = true; decir(tx('h_buscador')); }
      buscador({});
    } else {
      saludo();
      if (window.matchMedia('(min-width: 750px)').matches) entrada.focus();
    }
    bajar();
  }
  function cerrar() {
    panel.hidden = true;
    raiz.classList.remove('is-abierto');
    lanzador.setAttribute('aria-expanded', 'false');
    lanzador.focus();
  }
  lanzador.addEventListener('click', function () { panel.hidden ? abrir(false) : cerrar(); });
  raiz.querySelector('.lf-asis__cerrar').addEventListener('click', cerrar);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) cerrar(); });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href$="#buscador-discos"]');
    if (!a) return;
    e.preventDefault();
    abrir(true);
  });
  raiz.querySelector('.lf-asis__escribir').addEventListener('submit', function (e) {
    e.preventDefault();
    var texto = entrada.value.trim();
    if (!texto) return;
    entrada.value = '';
    if (!iniciado) { iniciado = true; }
    yo(texto);
    procesar(texto);
  });

  recuperarHistorial();
  if (location.hash === '#buscador-discos') setTimeout(function () { abrir(true); }, 400);

  /* Aviso pequeño una sola vez por visitante, en portada y colecciones */
  if (!leer('lf-asis-visto') && (plantilla === 'index' || plantilla === 'collection')) {
    setTimeout(function () {
      if (!panel.hidden) return;
      aviso.hidden = false;
      guardar('lf-asis-visto', '1');
      setTimeout(function () { aviso.hidden = true; }, 9000);
    }, 8000);
  }
  aviso.addEventListener('click', function () { abrir(false); });

  /* Vuelta tras enviar el formulario de contacto del asistente */
  document.addEventListener('submit', function (e) {
    if (e.target.id === 'lf-asis-form') { try { sessionStorage.setItem('lf-asis-enviado', '1'); } catch (x) {} }
  });
  var enviado = null, posted = /[?&]contact_posted=true/.test(location.search);
  try {
    enviado = sessionStorage.getItem('lf-asis-enviado');
    if (posted || location.pathname.indexOf('/challenge') === -1) sessionStorage.removeItem('lf-asis-enviado');
  } catch (e) {}
  if (enviado && posted) {
    iniciado = true;
    abrir(false);
    decir(tx('h_gracias'));
  }
})();
